import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
const defaultOptions = {} as const
/**
 * All built-in and custom scalars, mapped to their actual values
 */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /**
   * Amh {unit, value}
   */
  Amh: Gaia.Amh
  /**
   * A date string, such as 2007-12-03, compliant with the `full-date`
   * format outlined in section 5.6 of the RFC 3339 profile of the ISO
   * 8601 standard for representation of dates and times using the
   * Gregorian calendar.
   */
  Date: string
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant
   * with the `date-time` format outlined in section 5.6 of the RFC 3339
   * profile of the ISO 8601 standard for representation of dates and
   * times using the Gregorian calendar.
   */
  DateTime: string
  /**
   * A field whose value conforms to the standard internet email address
   * format as specified in RFC822:
   * https://www.w3.org/Protocols/rfc822/.
   */
  EmailAddress: string
  /**
   * Height {unit, value}
   */
  Height: Gaia.Height
  /**
   * A literal false value
   */
  LiteralFalse: false
  /**
   * A literal true value
   */
  LiteralTrue: true
  /**
   * A safe monetary value representation thanks to Dinero.js
   */
  Money: Gaia.Money
  /**
   * A string that cannot be passed as an empty value
   */
  NonEmptyString: string
  /**
   * Floats that will have a value of 0 or more.
   */
  NonNegativeFloat: number
  /**
   * Integers that will have a value of 0 or more.
   */
  NonNegativeInt: number
  /**
   * Floats that will have a value greater than 0.
   */
  PositiveFloat: number
  /**
   * Integers that will have a value greater than 0.
   */
  PositiveInt: number
  /**
   * A field whose value conforms to the standard postal code formats
   * for United States, United Kingdom, Germany, Canada, France, Italy,
   * Australia, Netherlands, Spain, Denmark, Sweden, Belgium, India,
   * Austria, Portugal, Switzerland or Luxembourg.
   */
  PostalCode: string
  /**
   * Pointer/reference towards a unique entity {id: ID! __typename:
   * String!}
   */
  Ref: { __typename: string; id: string }
  /**
   * A time string at UTC, such as 10:15:30Z, compliant with the
   * `full-time` format outlined in section 5.6 of the RFC 3339profile
   * of the ISO 8601 standard for representation of dates and times
   * using the Gregorian calendar.
   */
  Time: any
  /**
   * The javascript `Date` as integer. Type represents date and time as
   * number of milliseconds from start of UNIX epoch.
   */
  Timestamp: number
  /**
   * Weight {unit, value}
   */
  Weight: Gaia.Weight
}

export type AcceptPlanQuoteInput = {
  readonly consentedToShareInfoWithClinic?: InputMaybe<Scalars['Boolean']>
  readonly fullLegalName?: InputMaybe<Scalars['String']>
  readonly partnerEmail?: InputMaybe<Scalars['String']>
  readonly partnerFullLegalName?: InputMaybe<Scalars['String']>
  readonly quoteId: Scalars['ID']
}

export type Address = {
  readonly __typename?: 'Address'
  readonly city?: Maybe<Scalars['String']>
  readonly country?: Maybe<Scalars['NonEmptyString']>
  readonly county?: Maybe<Scalars['String']>
  readonly line1?: Maybe<Scalars['NonEmptyString']>
  readonly line2?: Maybe<Scalars['String']>
  readonly postcode?: Maybe<Scalars['NonEmptyString']>
}

export type AddressInput = {
  readonly city?: InputMaybe<Scalars['String']>
  readonly country: Scalars['NonEmptyString']
  readonly county?: InputMaybe<Scalars['String']>
  readonly line1: Scalars['NonEmptyString']
  readonly line2?: InputMaybe<Scalars['String']>
  readonly postcode: Scalars['NonEmptyString']
}

export enum AddressSource {
  Manual = 'MANUAL',
  PostcodeLookup = 'POSTCODE_LOOKUP',
}

/**
 * Periods of time spent concieving
 */
export enum AttemptedConceptionPeriod {
  Between_12_24Months = 'BETWEEN_12_24_MONTHS',
  LessThan_12Months = 'LESS_THAN_12_MONTHS',
  MoreThan_24Months = 'MORE_THAN_24_MONTHS',
  Unknown = 'UNKNOWN',
}

export enum AuthProvider {
  Credentials = 'Credentials',
  Email = 'Email',
  Google = 'Google',
}

export type BundleProductExperiment = {
  readonly __typename?: 'BundleProductExperiment'
  readonly createdAt: Scalars['DateTime']
  readonly createdBy: Scalars['String']
  readonly id: Scalars['ID']
  readonly metaData?: Maybe<BundleProductExperimentMetaData>
  readonly userId: Scalars['ID']
  readonly version: Scalars['NonNegativeInt']
}

export type BundleProductExperimentMetaData = {
  readonly __typename?: 'BundleProductExperimentMetaData'
  readonly clinicId: Scalars['ID']
  readonly procedures: ReadonlyArray<Maybe<IvfProcedure>>
  readonly products: ReadonlyArray<BundleProductExperimentProducts>
  readonly singleCycleCost: BundleProductExperimentSingleCycleCost
}

export type BundleProductExperimentProducts = {
  readonly __typename?: 'BundleProductExperimentProducts'
  readonly name: Scalars['String']
  readonly variants: ReadonlyArray<BundleProductExperimentVariant>
}

export type BundleProductExperimentSingleCycleCost = {
  readonly __typename?: 'BundleProductExperimentSingleCycleCost'
  readonly cycleCost: Scalars['Money']
  readonly cycleCostWithoutMedication: Scalars['Money']
  readonly medicationShare: Scalars['NonNegativeFloat']
}

export type BundleProductExperimentVariant = {
  readonly __typename?: 'BundleProductExperimentVariant'
  readonly cycles: Scalars['NonNegativeInt']
  readonly price: Scalars['Money']
  readonly refund: Scalars['NonNegativeFloat']
}

export type CheckOpenBankingConnectionStatusError = {
  readonly __typename?: 'CheckOpenBankingConnectionStatusError'
  readonly error: Scalars['String']
  readonly ok: Scalars['LiteralFalse']
}

export type CheckOpenBankingConnectionStatusOk = {
  readonly __typename?: 'CheckOpenBankingConnectionStatusOk'
  readonly ok: Scalars['LiteralTrue']
  readonly value: ReadonlyArray<OpenBankingConnectionStatus>
}

export type CheckOpenBankingConnectionStatusResult =
  | CheckOpenBankingConnectionStatusError
  | CheckOpenBankingConnectionStatusOk

export type Clinic = {
  readonly __typename?: 'Clinic'
  readonly id: Scalars['ID']
  readonly name: Scalars['String']
  readonly usaState: UsaState
}

export type ClinicConsultationInput = {
  readonly bookedFutureConsultation?: InputMaybe<Scalars['Boolean']>
  readonly clinicId: Scalars['String']
  readonly hadConsultation: Scalars['Boolean']
  readonly hadPreTreatmentScreenings?: InputMaybe<Scalars['Boolean']>
  readonly intendedTreatmentStartDate?: InputMaybe<Scalars['Date']>
  readonly interestedInBookingAConsultation?: InputMaybe<Scalars['Boolean']>
}

export type ClinicInput = {
  readonly id: Scalars['ID']
  readonly name: Scalars['String']
}

export type ClinicsPaged = {
  readonly __typename?: 'ClinicsPaged'
  /**
   * Count of available results, considering current filters - if any
   */
  readonly count?: Maybe<Scalars['NonNegativeInt']>
  readonly data: ReadonlyArray<Clinic>
  /**
   * Meta data about how results have been paginated in response
   */
  readonly page?: Maybe<OffsetPage>
}

/**
 * Types of consultations users may have already had
 */
export enum ConsultationType {
  Gp = 'GP',
  NhsHospital = 'NHS_HOSPITAL',
  None = 'NONE',
  Obgyn = 'OBGYN',
  Other = 'OTHER',
  PrivateFertilityClinic = 'PRIVATE_FERTILITY_CLINIC',
}

export enum Country {
  Gb = 'GB',
  Us = 'US',
}

export type CreateCreditApplicationError = {
  readonly __typename?: 'CreateCreditApplicationError'
  readonly error: Scalars['String']
  readonly ok: Scalars['LiteralFalse']
}

export type CreateCreditApplicationOk = {
  readonly __typename?: 'CreateCreditApplicationOk'
  readonly ok: Scalars['LiteralTrue']
  readonly value: Scalars['Boolean']
}

export type CreateCreditApplicationResult =
  | CreateCreditApplicationError
  | CreateCreditApplicationOk

export type CreditApplication = {
  readonly __typename?: 'CreditApplication'
  /**
   * @deprecated Use status instead.
   */
  readonly assessment?: Maybe<CreditApplicationAssessment>
  readonly creditUnderwritingService?: Maybe<CreditUnderwritingService>
  readonly externalApplicationId?: Maybe<Scalars['String']>
  readonly id: Scalars['ID']
  readonly renderApplicationId?: Maybe<Scalars['Int']>
  readonly status: CreditApplicationStatus
}

export type CreditApplicationAssessment = {
  readonly __typename?: 'CreditApplicationAssessment'
  readonly assessedBy?: Maybe<Scalars['String']>
  readonly checkId: Scalars['ID']
  readonly createdAt: Scalars['Date']
  readonly id: Scalars['ID']
  readonly note?: Maybe<Scalars['String']>
  readonly outcome?: Maybe<RiskOutcome>
  readonly userId: Scalars['ID']
}

export enum CreditApplicationStatus {
  Accepted = 'ACCEPTED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Rejected = 'REJECTED',
}

export type CreditProfile = {
  readonly country: Country
  readonly dateOfBirth: Scalars['Date']
  readonly dependents: Scalars['Int']
  readonly email: Scalars['EmailAddress']
  readonly employmentStatus: EmploymentStatus
  readonly firstName: Scalars['NonEmptyString']
  readonly grossAnnualIncome: Scalars['Money']
  readonly id: Scalars['ID']
  readonly individual: RiskIndividualRole
  readonly lastName: Scalars['NonEmptyString']
  readonly monthlyExpenses: Scalars['Money']
  readonly monthlyRentOrMortgage: Scalars['Money']
  readonly namePrefix: Scalars['NonEmptyString']
  readonly residentialStatus: ResidentialStatus
}

export type CreditProfileInput = {
  readonly country: Country
  readonly profile: LocalisedCreditProfile
  readonly userId: Scalars['ID']
}

export enum CreditUnderwritingService {
  Alloy = 'ALLOY',
  Render = 'RENDER',
}

/**
 * The type of an embryo transfer
 */
export enum EmbryoTransferType {
  Fresh = 'FRESH',
  Frozen = 'FROZEN',
}

export enum EmploymentStatus {
  Disability = 'DISABILITY',
  FullTimeEmployed = 'FULL_TIME_EMPLOYED',
  Homemaker = 'HOMEMAKER',
  LongTermBenefits = 'LONG_TERM_BENEFITS',
  Other = 'OTHER',
  PartTimeEmployed = 'PART_TIME_EMPLOYED',
  Pension = 'PENSION',
  SelfEmployed = 'SELF_EMPLOYED',
  Student = 'STUDENT',
  TemporarilyEmployed = 'TEMPORARILY_EMPLOYED',
  Unemployed = 'UNEMPLOYED',
}

/**
 * The types of procedure available on top of standard IVF which the
 * user can explicity declare
 */
export enum ExplicitIvfProcedure {
  AdditionalScans = 'ADDITIONAL_SCANS',
  ArtificialEggActivationCalciumIonophore = 'ARTIFICIAL_EGG_ACTIVATION_CALCIUM_IONOPHORE',
  AssistedHatching = 'ASSISTED_HATCHING',
  DuoStimulation = 'DUO_STIMULATION',
  EmbryoDonation = 'EMBRYO_DONATION',
  EmbryoGlue = 'EMBRYO_GLUE',
  EmbryoScope = 'EMBRYO_SCOPE',
  EndometrialScratching = 'ENDOMETRIAL_SCRATCHING',
  Era = 'ERA',
  Fbc = 'FBC',
  FreezeAll = 'FREEZE_ALL',
  Geri = 'GERI',
  Hysteroscopy = 'HYSTEROSCOPY',
  Icsi = 'ICSI',
  ImmunologicalTests = 'IMMUNOLOGICAL_TESTS',
  Imsi = 'IMSI',
  Intralipids = 'INTRALIPIDS',
  IntrauterineCulture = 'INTRAUTERINE_CULTURE',
  Laperoscopy = 'LAPEROSCOPY',
  Medication = 'MEDICATION',
  MildIvf = 'MILD_IVF',
  None = 'NONE',
  Pgd = 'PGD',
  PgtA = 'PGT_A',
  PgtM = 'PGT_M',
  PgtSr = 'PGT_SR',
  Picsi = 'PICSI',
  SingleVialDonorSperm = 'SINGLE_VIAL_DONOR_SPERM',
  Ssr = 'SSR',
  ThyroidTests = 'THYROID_TESTS',
  TimelapseImaging = 'TIMELAPSE_IMAGING',
  ViralScreening = 'VIRAL_SCREENING',
}

/**
 * Declared and other fertility diagnoses
 */
export enum FertilityDiagnosis {
  DontKnow = 'DONT_KNOW',
  Dor = 'DOR',
  Endometriosis = 'ENDOMETRIOSIS',
  MaleFactor = 'MALE_FACTOR',
  None = 'NONE',
  Other = 'OTHER',
  OvulatoryDisease = 'OVULATORY_DISEASE',
  Pcos = 'PCOS',
  TubalDisease = 'TUBAL_DISEASE',
  Unexplained = 'UNEXPLAINED',
  Uterine = 'UTERINE',
}

export type FinancePlan = {
  readonly __typename?: 'FinancePlan'
  readonly annualInterestRate: Scalars['NonNegativeFloat']
  readonly apr: Scalars['NonNegativeFloat']
  readonly id: Scalars['ID']
  readonly maxFinancedFreshRounds?: Maybe<Scalars['PositiveInt']>
  readonly maxFinancedLiability: Scalars['Money']
  readonly repaymentPeriodInMonths: Scalars['PositiveInt']
  readonly representativeRepaymentTable: ReadonlyArray<RepresentativeRepayment>
}

export type GbCreditProfile = CreditProfile & {
  readonly __typename?: 'GbCreditProfile'
  readonly address: GbCreditProfileAddress
  readonly country: Country
  readonly dateOfBirth: Scalars['Date']
  readonly dependents: Scalars['Int']
  readonly email: Scalars['EmailAddress']
  readonly employmentStatus: EmploymentStatus
  readonly firstName: Scalars['NonEmptyString']
  readonly grossAnnualIncome: Scalars['Money']
  readonly id: Scalars['ID']
  readonly individual: RiskIndividualRole
  readonly lastName: Scalars['NonEmptyString']
  readonly monthlyExpenses: Scalars['Money']
  readonly monthlyRentOrMortgage: Scalars['Money']
  readonly namePrefix: Scalars['NonEmptyString']
  readonly openBankingConnected: Scalars['Boolean']
  readonly previousAddresses?: Maybe<ReadonlyArray<GbCreditProfileAddress>>
  readonly renderApplicantId?: Maybe<Scalars['Int']>
  readonly residentialStatus: ResidentialStatus
}

export type GbCreditProfileAddress = {
  readonly __typename?: 'GbCreditProfileAddress'
  readonly city: Scalars['String']
  readonly country: Scalars['String']
  readonly district?: Maybe<Scalars['String']>
  readonly flat?: Maybe<Scalars['String']>
  readonly houseName?: Maybe<Scalars['String']>
  readonly houseNumber?: Maybe<Scalars['String']>
  readonly moveInDate: Scalars['Date']
  readonly postcode: Scalars['String']
  readonly residentialStatus?: Maybe<ResidentialStatus>
  readonly source?: Maybe<AddressSource>
  readonly street: Scalars['String']
}

export type GbCreditProfileAddressInput = {
  readonly city: Scalars['NonEmptyString']
  readonly country: Scalars['NonEmptyString']
  readonly district?: InputMaybe<Scalars['NonEmptyString']>
  readonly flat?: InputMaybe<Scalars['NonEmptyString']>
  readonly houseName?: InputMaybe<Scalars['NonEmptyString']>
  readonly houseNumber?: InputMaybe<Scalars['NonEmptyString']>
  readonly moveInDate: Scalars['Date']
  readonly postcode: Scalars['NonEmptyString']
  readonly residentialStatus?: InputMaybe<ResidentialStatus>
  readonly source?: InputMaybe<AddressSource>
  readonly street: Scalars['NonEmptyString']
}

export type GbCreditProfileInput = {
  readonly address: GbCreditProfileAddressInput
  readonly country: Country
  readonly dateOfBirth: Scalars['Date']
  readonly dependents: Scalars['Int']
  readonly email: Scalars['EmailAddress']
  readonly employmentStatus: EmploymentStatus
  readonly firstName: Scalars['NonEmptyString']
  readonly grossAnnualIncome: Scalars['Money']
  readonly individual: RiskIndividualRole
  readonly lastName: Scalars['NonEmptyString']
  readonly monthlyExpenses?: InputMaybe<Scalars['Money']>
  readonly monthlyRentOrMortgage: Scalars['Money']
  readonly namePrefix: Scalars['NonEmptyString']
  readonly openBankingConnected: Scalars['Boolean']
  readonly previousAddresses?: InputMaybe<
    ReadonlyArray<GbCreditProfileAddressInput>
  >
  readonly residentialStatus: ResidentialStatus
  readonly userId: Scalars['ID']
}

/**
 * The person's gender identity
 */
export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER',
}

export enum HealthInsuranceCoverage {
  DiagnosticTesting = 'DIAGNOSTIC_TESTING',
  DontKnow = 'DONT_KNOW',
  IvfTreatment = 'IVF_TREATMENT',
  Medication = 'MEDICATION',
  None = 'NONE',
  OtherFertilityTreatment = 'OTHER_FERTILITY_TREATMENT',
}

export type IdentityVerification = {
  readonly __typename?: 'IdentityVerification'
  readonly id: Scalars['ID']
  readonly individual: RiskIndividualRole
  /**
   * @deprecated Couples implementation to riskProfiles and is not used
   */
  readonly riskProfileId: Scalars['ID']
  readonly userId: Scalars['ID']
  readonly verificationMethod: IdentityVerificationMethod
  readonly verifiedAt: Scalars['DateTime']
  readonly verifiedBy: Scalars['EmailAddress']
}

export enum IdentityVerificationMethod {
  IdDocuments = 'ID_DOCUMENTS',
  Render = 'RENDER',
  Transunion = 'TRANSUNION',
}

export type IncomeVerification = {
  readonly __typename?: 'IncomeVerification'
  readonly id: Scalars['ID']
  readonly individual: RiskIndividualRole
  readonly riskProfileId: Scalars['ID']
  readonly userId: Scalars['ID']
  readonly verificationMethod: IncomeVerificationMethod
  readonly verifiedAt: Scalars['DateTime']
  readonly verifiedBy: Scalars['EmailAddress']
  readonly verifiedNetMonthlyIncome: Scalars['Money']
}

export enum IncomeVerificationMethod {
  BankStatements = 'BANK_STATEMENTS',
  OpenBanking = 'OPEN_BANKING',
  Payslips = 'PAYSLIPS',
  Render = 'RENDER',
  Transunion = 'TRANSUNION',
}

/**
 * See prisma schema and types for more details
 */
export enum IndividualRelationship {
  Donor = 'DONOR',
  None = 'NONE',
  /**
   * @deprecated Use UNKNOWN
   */
  Other = 'OTHER',
  Partner = 'PARTNER',
  Self = 'SELF',
  Surrogate = 'SURROGATE',
  Unknown = 'UNKNOWN',
  /**
   * @deprecated Use UNKNOWN
   */
  Unsure = 'UNSURE',
}

/**
 * Biological sex
 */
export enum IndividualSex {
  Female = 'FEMALE',
  Male = 'MALE',
  Unknown = 'UNKNOWN',
}

/**
 * Period of time intend to start IVF within
 */
export enum IntendedStartPeriod {
  DontKnow = 'DONT_KNOW',
  NextSixMonths = 'NEXT_SIX_MONTHS',
  NextThreeMonths = 'NEXT_THREE_MONTHS',
  NextTwelveMonths = 'NEXT_TWELVE_MONTHS',
}

export type IoPlanQuote = PlanQuote & {
  readonly __typename?: 'IoPlanQuote'
  readonly acceptedAt?: Maybe<Scalars['DateTime']>
  readonly annualInterestRate: Scalars['NonNegativeFloat']
  readonly clinic: Clinic
  readonly coverPeriods: Scalars['PositiveInt']
  readonly expiresAt: Scalars['DateTime']
  readonly financePlan?: Maybe<FinancePlan>
  readonly firstTreatmentWithinPeriods: Scalars['PositiveInt']
  readonly freshLiability: Scalars['Money']
  readonly freshPremium?: Maybe<Scalars['Money']>
  readonly frozenLiability: Scalars['Money']
  readonly frozenPremium?: Maybe<Scalars['Money']>
  readonly id: Scalars['ID']
  readonly lastViewedAt?: Maybe<Scalars['DateTime']>
  readonly maxFinancedFreshRounds?: Maybe<Scalars['PositiveInt']>
  readonly maxFinancedLiability?: Maybe<Scalars['Money']>
  readonly monthlyMembershipLiability: Scalars['Money']
  readonly pathway: TreatmentProfile
  readonly personalMessage?: Maybe<Scalars['String']>
  readonly procedures: ReadonlyArray<IvfProcedure>
  readonly profile: TreatmentProfile
  readonly repaymentPeriods: Scalars['NonNegativeInt']
  readonly representativeLoanExample?: Maybe<RepresentativeLoanExample>
  readonly representativeRepaymentTable: ReadonlyArray<RepresentativeRepayment>
  readonly roundsCovered: Scalars['PositiveInt']
  readonly sentAt: Scalars['DateTime']
  readonly status: QuoteStatus
  readonly user: User
  readonly variant: PlanProductVariant
}

/**
 * What stage are you at in your IVF journey?
 */
export enum IvfJourneyStage {
  HadIvfPreviously = 'HAD_IVF_PREVIOUSLY',
  InSixMonthsOrMore = 'IN_SIX_MONTHS_OR_MORE',
  InThreeToSixMonths = 'IN_THREE_TO_SIX_MONTHS',
  InZeroToThreeMonths = 'IN_ZERO_TO_THREE_MONTHS',
  JustBrowsing = 'JUST_BROWSING',
  TryingNaturally = 'TRYING_NATURALLY',
}

/**
 * The types of procedure available on top of standard IVF
 */
export enum IvfProcedure {
  AdditionalScans = 'ADDITIONAL_SCANS',
  ArtificialEggActivationCalciumIonophore = 'ARTIFICIAL_EGG_ACTIVATION_CALCIUM_IONOPHORE',
  AssistedHatching = 'ASSISTED_HATCHING',
  DuoStimulation = 'DUO_STIMULATION',
  EggDonation = 'EGG_DONATION',
  EmbryoDonation = 'EMBRYO_DONATION',
  EmbryoGlue = 'EMBRYO_GLUE',
  EmbryoScope = 'EMBRYO_SCOPE',
  EndometrialScratching = 'ENDOMETRIAL_SCRATCHING',
  Era = 'ERA',
  Fbc = 'FBC',
  FreezeAll = 'FREEZE_ALL',
  Geri = 'GERI',
  Hysteroscopy = 'HYSTEROSCOPY',
  Icsi = 'ICSI',
  ImmunologicalTests = 'IMMUNOLOGICAL_TESTS',
  Imsi = 'IMSI',
  Intralipids = 'INTRALIPIDS',
  IntrauterineCulture = 'INTRAUTERINE_CULTURE',
  Laperoscopy = 'LAPEROSCOPY',
  Medication = 'MEDICATION',
  MildIvf = 'MILD_IVF',
  None = 'NONE',
  Pgd = 'PGD',
  PgtA = 'PGT_A',
  PgtM = 'PGT_M',
  PgtSr = 'PGT_SR',
  Picsi = 'PICSI',
  SharedMotherhood = 'SHARED_MOTHERHOOD',
  SingleVialDonorSperm = 'SINGLE_VIAL_DONOR_SPERM',
  SpermDonation = 'SPERM_DONATION',
  Ssr = 'SSR',
  Surrogate = 'SURROGATE',
  ThyroidTests = 'THYROID_TESTS',
  TimelapseImaging = 'TIMELAPSE_IMAGING',
  ViralScreening = 'VIRAL_SCREENING',
}

export type LetoPlanQuote = PlanQuote & {
  readonly __typename?: 'LetoPlanQuote'
  readonly acceptedAt?: Maybe<Scalars['DateTime']>
  readonly annualInterestRate: Scalars['NonNegativeFloat']
  readonly clinic: Clinic
  readonly coverPeriods: Scalars['PositiveInt']
  readonly cycleLiabilityPostDiscount: Scalars['Money']
  readonly cyclesCovered: Scalars['Int']
  readonly expiresAt: Scalars['DateTime']
  readonly firstTreatmentWithinPeriods: Scalars['PositiveInt']
  readonly id: Scalars['ID']
  readonly lastViewedAt?: Maybe<Scalars['DateTime']>
  readonly maxFinancedLiability?: Maybe<Scalars['Money']>
  readonly maxPaymentPeriodYears: Scalars['Int']
  readonly pathway: TreatmentProfile
  readonly perCycleMembershipLiability: Scalars['Money']
  readonly personalMessage?: Maybe<Scalars['String']>
  readonly procedures: ReadonlyArray<IvfProcedure>
  readonly profile: TreatmentProfile
  readonly protectionFee: Scalars['Money']
  readonly refundSchema: ReadonlyArray<Scalars['Float']>
  readonly repaymentPeriods: Scalars['NonNegativeInt']
  readonly repaymentScenarios: ReadonlyArray<LetoRepaymentScenario>
  readonly repaymentScenariosOverPeriod: ReadonlyArray<LetoRepaymentScenarioForPeriod>
  readonly sentAt: Scalars['DateTime']
  readonly status: QuoteStatus
  readonly user: User
  readonly variant: PlanProductVariant
}

export type LetoPlanQuoteRepaymentScenariosOverPeriodArgs = {
  periods: ReadonlyArray<Scalars['String']>
}

/**
 * A repayment scenario dependant on the number of cycles started
 */
export type LetoRepaymentScenario = {
  readonly __typename?: 'LetoRepaymentScenario'
  readonly apr: Scalars['NonNegativeFloat']
  readonly fixedCycleCost: Scalars['Money']
  readonly minimumMonthlyRepayment: Scalars['Money']
  readonly numberOfCyclesStarted: Scalars['Int']
  readonly protectionFee: Scalars['Money']
  readonly refund: RefundScenario
  readonly totalFixedCycleCost: Scalars['Money']
  readonly totalPayable: Scalars['Money']
}

export type LetoRepaymentScenarioForPeriod = {
  readonly __typename?: 'LetoRepaymentScenarioForPeriod'
  readonly period: Scalars['String']
  readonly scenarios: ReadonlyArray<LetoRepaymentScenario>
}

export type LocalisedCreditProfile = {
  readonly gb?: InputMaybe<GbCreditProfileInput>
  readonly us?: InputMaybe<UsCreditProfileInput>
}

export type Mutation = {
  readonly __typename?: 'Mutation'
  readonly acceptPlanQuote: PlanQuote
  readonly checkOpenBankingConnectionStatus: CheckOpenBankingConnectionStatusResult
  readonly createCreditApplication: CreateCreditApplicationResult
  readonly createUser?: Maybe<User>
  readonly requestEmailVerification?: Maybe<Scalars['Boolean']>
  readonly requestOpenBankingLink: RequestOpenBankingLinkResult
  readonly requestOwnQuote: RequestOwnQuoteResponse
  readonly requestPasswordReset?: Maybe<Scalars['Boolean']>
  readonly requestUploadTreatmentProofPresignedUrl: PreSignedObject
  readonly requestViewTreatmentProofPresignedUrl: Scalars['String']
  readonly resetUserPassword?: Maybe<Scalars['Boolean']>
  readonly saveCreditProfile: SaveCreditProfileResult
  readonly setCreditProfileOpenBankingConnected: SetCreditProfileOpenBankingConnectedResult
  readonly signInUser?: Maybe<User>
  readonly trackPlanQuoteView: TrackPlanQuoteViewResult
  readonly updateOwnAddress?: Maybe<User>
  readonly updateOwnEmailAddress?: Maybe<User>
  readonly updateOwnPassword?: Maybe<Scalars['Boolean']>
  /**
   * Enable users to update their treatment profile, incrementally
   */
  readonly updateOwnTreatmentProfile: TreatmentProfile
  /**
   * Enable users to update their personal information
   */
  readonly updateSelf?: Maybe<User>
  readonly uploadTreatmentProofDocument: UploadTreatmentProofDocumentResult
  readonly verifyEmailAddress?: Maybe<User>
}

export type MutationAcceptPlanQuoteArgs = {
  acceptPlanQuoteInput: AcceptPlanQuoteInput
}

export type MutationCheckOpenBankingConnectionStatusArgs = {
  individuals: ReadonlyArray<RiskIndividualRole>
}

export type MutationCreateCreditApplicationArgs = {
  creditProfileIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>
  individuals: ReadonlyArray<RiskIndividualRole>
}

export type MutationCreateUserArgs = {
  clinicConsultation?: InputMaybe<ClinicConsultationInput>
  consentedToShareInfoWithClinic?: InputMaybe<Scalars['Boolean']>
  country?: InputMaybe<Country>
  dateOfBirth?: InputMaybe<Scalars['Date']>
  email: Scalars['EmailAddress']
  firstName?: InputMaybe<Scalars['String']>
  gender?: InputMaybe<Gender>
  hadInitialDiagnosticTest?: InputMaybe<Scalars['Boolean']>
  healthInsuranceCoverage?: InputMaybe<ReadonlyArray<HealthInsuranceCoverage>>
  intendedStartPeriod?: InputMaybe<IntendedStartPeriod>
  isReadyToStartIVF?: InputMaybe<Scalars['Boolean']>
  lastName?: InputMaybe<Scalars['String']>
  marketingEmails?: InputMaybe<Scalars['Boolean']>
  memberReferrer?: InputMaybe<Scalars['String']>
  otherUpfrontPaymentPreference?: InputMaybe<Scalars['String']>
  partnerFirstName?: InputMaybe<Scalars['String']>
  partnerLastName?: InputMaybe<Scalars['String']>
  password: Scalars['String']
  postcode?: InputMaybe<Scalars['String']>
  referralCodeUsed?: InputMaybe<Scalars['String']>
  referrer: Referrer
  referrerClinicId?: InputMaybe<Scalars['String']>
  stepsLeftToComplete?: InputMaybe<ReadonlyArray<StepLeftToComplete>>
  unlistedOtherReferrer?: InputMaybe<Scalars['String']>
  unlistedReferrerClinicName?: InputMaybe<Scalars['String']>
  upfrontPaymentPreference?: InputMaybe<UpfrontPayment>
  usaState?: InputMaybe<UsaState>
  utm?: InputMaybe<UtmInput>
}

export type MutationRequestEmailVerificationArgs = {
  email: Scalars['String']
}

export type MutationRequestOpenBankingLinkArgs = {
  creditProfileId: Scalars['ID']
}

export type MutationRequestOwnQuoteArgs = {
  requestOwnQuoteInput: RequestOwnQuoteInput
}

export type MutationRequestPasswordResetArgs = {
  email: Scalars['String']
}

export type MutationRequestViewTreatmentProofPresignedUrlArgs = {
  path: Scalars['String']
}

export type MutationResetUserPasswordArgs = {
  newPassword: Scalars['String']
  token: Scalars['String']
}

export type MutationSaveCreditProfileArgs = {
  profile: CreditProfileInput
}

export type MutationSetCreditProfileOpenBankingConnectedArgs = {
  creditProfileId: Scalars['ID']
}

export type MutationSignInUserArgs = {
  email: Scalars['EmailAddress']
  password: Scalars['String']
}

export type MutationTrackPlanQuoteViewArgs = {
  quoteId: Scalars['ID']
}

export type MutationUpdateOwnAddressArgs = {
  address: AddressInput
}

export type MutationUpdateOwnEmailAddressArgs = {
  email: Scalars['EmailAddress']
}

export type MutationUpdateOwnPasswordArgs = {
  currentPassword: Scalars['String']
  newPassword: Scalars['String']
}

export type MutationUpdateOwnTreatmentProfileArgs = {
  health?: InputMaybe<TreatmentHealthInput>
  history?: InputMaybe<TreatmentHistoryInput>
  ivfHistory?: InputMaybe<TreatmentIvfHistoryInput>
  journey?: InputMaybe<TreatmentJourneyInput>
  wholeProfile?: InputMaybe<TreatmentWholeInput>
}

export type MutationUpdateSelfArgs = {
  info: UserUpdateInput
}

export type MutationUploadTreatmentProofDocumentArgs = {
  document: UploadDocumentInput
}

export type MutationVerifyEmailAddressArgs = {
  token: Scalars['String']
}

export enum NextGaiaStep {
  AcceptQuote = 'ACCEPT_QUOTE',
  ApplyForPlan = 'APPLY_FOR_PLAN',
  AwaitQuote = 'AWAIT_QUOTE',
  CompleteFertilityProfile = 'COMPLETE_FERTILITY_PROFILE',
  PayFirstPremium = 'PAY_FIRST_PREMIUM',
  ReceivePlan = 'RECEIVE_PLAN',
  ReceiveQuote = 'RECEIVE_QUOTE',
  ReceiveRiskAssessmentResponse = 'RECEIVE_RISK_ASSESSMENT_RESPONSE',
  ReceiveTreatmentProofResponse = 'RECEIVE_TREATMENT_PROOF_RESPONSE',
  RequestQuote = 'REQUEST_QUOTE',
  RequestQuoteAfterExpiry = 'REQUEST_QUOTE_AFTER_EXPIRY',
  SignDocuments = 'SIGN_DOCUMENTS',
  SubmitObPartnerOnly = 'SUBMIT_OB_PARTNER_ONLY',
  SubmitObProspectOnly = 'SUBMIT_OB_PROSPECT_ONLY',
  SubmitObProspectPartner = 'SUBMIT_OB_PROSPECT_PARTNER',
  SubmitTreatmentProof = 'SUBMIT_TREATMENT_PROOF',
}

/**
 * NHS funding eligibility statuses
 */
export enum NhsFundingEligibility {
  CompletedNhs = 'COMPLETED_NHS',
  DontKnow = 'DONT_KNOW',
  EligibleConsideringPrivate = 'ELIGIBLE_CONSIDERING_PRIVATE',
  EligiblePresentlyNhs = 'ELIGIBLE_PRESENTLY_NHS',
  Ineligible = 'INELIGIBLE',
  Other = 'OTHER',
}

/**
 * A generic offset pagination meta type
 */
export type OffsetPage = {
  readonly __typename?: 'OffsetPage'
  readonly first: Scalars['NonNegativeInt']
  readonly offset: Scalars['NonNegativeInt']
}

/**
 * A generic input to control pagination of results
 */
export type OffsetPageInput = {
  readonly first: Scalars['NonNegativeInt']
  readonly offset: Scalars['NonNegativeInt']
}

export type OpenBankingConnectionStatus = {
  readonly __typename?: 'OpenBankingConnectionStatus'
  readonly individual: RiskIndividualRole
  readonly status: OpenBankingConnectionStatuses
}

export enum OpenBankingConnectionStatuses {
  Connected = 'CONNECTED',
  NotConnected = 'NOT_CONNECTED',
}

/**
 * A container for details about an individual involved in a
 * pathway/treatment/plan
 */
export type PathwayIndividual = {
  readonly __typename?: 'PathwayIndividual'
  readonly amh?: Maybe<Scalars['Amh']>
  readonly dateOfBirth?: Maybe<Scalars['Date']>
  readonly height?: Maybe<Scalars['Height']>
  readonly relationship: IndividualRelationship
  readonly sex: IndividualSex
  readonly weight?: Maybe<Scalars['Weight']>
}

/**
 * A container for details about an individual involved in a
 * pathway/treatment/plan
 */
export type PathwayIndividualInput = {
  readonly amh?: InputMaybe<Scalars['Amh']>
  readonly dateOfBirth?: InputMaybe<Scalars['Date']>
  readonly height?: InputMaybe<Scalars['Height']>
  readonly relationship: IndividualRelationship
  readonly sex: IndividualSex
  readonly weight?: InputMaybe<Scalars['Weight']>
}

/**
 * Current status of a prediction attached to a pathway
 */
export enum PathwayPredictionStatus {
  /**
   * We manually override a prediction result
   */
  Overridden = 'OVERRIDDEN',
  /**
   * When we have finished calculating and predicting a pathway
   */
  Predicted = 'PREDICTED',
  /**
   * If we cant handle the current set of inputs we need a way of
   * tracking and communicating to the user
   */
  Unsupported = 'UNSUPPORTED',
}

export enum PlanProductVariant {
  Alpha = 'ALPHA',
  AlphaFinancing = 'ALPHA_FINANCING',
  Bundle = 'BUNDLE',
  Financing = 'FINANCING',
  InsuranceAndFinancing = 'INSURANCE_AND_FINANCING',
  Leto = 'LETO',
  NoaInsuranceAndFinancing = 'NOA_INSURANCE_AND_FINANCING',
  RDMembers = 'R_D_MEMBERS',
}

/**
 * A quote for a plan
 */
export type PlanQuote = {
  readonly acceptedAt?: Maybe<Scalars['DateTime']>
  readonly annualInterestRate: Scalars['NonNegativeFloat']
  readonly clinic: Clinic
  readonly coverPeriods: Scalars['PositiveInt']
  readonly expiresAt: Scalars['DateTime']
  readonly firstTreatmentWithinPeriods: Scalars['PositiveInt']
  readonly id: Scalars['ID']
  readonly lastViewedAt?: Maybe<Scalars['DateTime']>
  readonly maxFinancedLiability?: Maybe<Scalars['Money']>
  readonly pathway: TreatmentProfile
  readonly personalMessage?: Maybe<Scalars['String']>
  readonly procedures: ReadonlyArray<IvfProcedure>
  readonly profile: TreatmentProfile
  readonly repaymentPeriods: Scalars['NonNegativeInt']
  readonly sentAt: Scalars['DateTime']
  readonly status: QuoteStatus
  readonly user: User
  readonly variant: PlanProductVariant
}

export type PlanQuotesFiltersInput = {
  readonly ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>
  readonly isAccepted?: InputMaybe<Scalars['Boolean']>
}

export type PostalAddress = {
  readonly __typename?: 'PostalAddress'
  readonly city?: Maybe<Scalars['String']>
  readonly country: Scalars['NonEmptyString']
  readonly county?: Maybe<Scalars['String']>
  readonly line1: Scalars['NonEmptyString']
  readonly line2?: Maybe<Scalars['String']>
  readonly postcode: Scalars['NonEmptyString']
}

export type PostalAddressInput = {
  readonly city?: InputMaybe<Scalars['String']>
  readonly country: Scalars['NonEmptyString']
  readonly county?: InputMaybe<Scalars['String']>
  readonly line1: Scalars['NonEmptyString']
  readonly line2?: InputMaybe<Scalars['String']>
  readonly postcode: Scalars['NonEmptyString']
}

export type PreSignedObject = {
  readonly __typename?: 'PreSignedObject'
  readonly id: Scalars['ID']
  readonly url: Scalars['String']
}

/**
 * A coded error object returned by letocus in the case of an error
 */
export type PredictionError = {
  readonly __typename?: 'PredictionError'
  readonly code: Scalars['String']
  readonly message: Scalars['String']
}

export type PremiumResponse = {
  readonly __typename?: 'PremiumResponse'
  readonly reasons?: Maybe<Scalars['String']>
  readonly recommendedNumRounds: Scalars['Int']
  readonly rounds?: Maybe<ReadonlyArray<Round>>
}

export type Query = {
  readonly __typename?: 'Query'
  readonly _Clinic: ReadonlyArray<Maybe<Clinic>>
  readonly _TreatmentProfile: ReadonlyArray<Maybe<TreatmentProfile>>
  readonly _User: ReadonlyArray<User>
  readonly clinics?: Maybe<ClinicsPaged>
  readonly getUserByEmailOrId: User
  /**
   * The current request viewer, can be passed a mock configuration in
   * development
   */
  readonly viewer: Viewer
}

export type Query_ClinicArgs = {
  refs: ReadonlyArray<Scalars['Ref']>
}

export type Query_TreatmentProfileArgs = {
  refs: ReadonlyArray<Scalars['Ref']>
}

export type Query_UserArgs = {
  refs: ReadonlyArray<Scalars['Ref']>
}

export type QueryClinicsArgs = {
  country?: InputMaybe<Country>
  page?: InputMaybe<OffsetPageInput>
}

export type QueryGetUserByEmailOrIdArgs = {
  email?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['String']>
}

export type QuoteCollection = {
  readonly __typename?: 'QuoteCollection'
  readonly bundleProductExperimentId?: Maybe<Scalars['ID']>
  readonly bundles?: Maybe<BundleProductExperiment>
  readonly clinic: Clinic
  readonly clinicId: Scalars['ID']
  readonly createdAt: Scalars['DateTime']
  readonly createdBy: Scalars['String']
  readonly id: Scalars['ID']
  readonly leto?: Maybe<PlanQuote>
  readonly planQuoteId?: Maybe<Scalars['ID']>
  readonly procedures: ReadonlyArray<IvfProcedure>
  readonly treatmentPathway: TreatmentProfile
  readonly treatmentPathwayId: Scalars['ID']
}

export type QuoteCollectionsFiltersInput = {
  readonly ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>
}

/**
 * A request for a quote made by an user
 */
export type QuoteRequest = {
  readonly __typename?: 'QuoteRequest'
  readonly clinic?: Maybe<Clinic>
  readonly createdAt: Scalars['DateTime']
  readonly fulfilledAt?: Maybe<Scalars['DateTime']>
  readonly id: Scalars['ID']
  readonly isPending: Scalars['Boolean']
  readonly requestedVariant?: Maybe<PlanProductVariant>
  readonly unlistedClinicName?: Maybe<Scalars['String']>
  readonly user: User
}

export enum QuoteStatus {
  Accepted = 'ACCEPTED',
  Archived = 'ARCHIVED',
  Expired = 'EXPIRED',
  PersonalisedInterestRate = 'PERSONALISED_INTEREST_RATE',
  PlanCreated = 'PLAN_CREATED',
  Sent = 'SENT',
  Viewed = 'VIEWED',
}

/**
 * Where did you hear about Gaia?
 */
export enum Referrer {
  BfnPodcast = 'BFN_PODCAST',
  ClinicReferral = 'CLINIC_REFERRAL',
  FertilityShow = 'FERTILITY_SHOW',
  FriendsOrFamily = 'FRIENDS_OR_FAMILY',
  GaiaMember = 'GAIA_MEMBER',
  Google = 'GOOGLE',
  Influencer = 'INFLUENCER',
  Other = 'OTHER',
  Podcast = 'PODCAST',
  SocialMedia = 'SOCIAL_MEDIA',
}

export type RefundScenario = {
  readonly __typename?: 'RefundScenario'
  readonly discount: Scalars['NonNegativeFloat']
  readonly reducedLoanAmount: Scalars['Money']
  readonly reducedMinimumMonthlyRepayment: Scalars['Money']
  readonly reducedTotalPayable: Scalars['Money']
}

export type Rejection = {
  readonly __typename?: 'Rejection'
  readonly reasons?: Maybe<ReadonlyArray<RejectionReason>>
}

/**
 * Reason why the user is currently rejected
 */
export enum RejectionReason {
  CreditApplicationFail = 'CREDIT_APPLICATION_FAIL',
  CreditApplicationTotalFail = 'CREDIT_APPLICATION_TOTAL_FAIL',
  IneligibleBmi = 'INELIGIBLE_BMI',
  IneligibleChances = 'INELIGIBLE_CHANCES',
  IneligibleEmbryoCarrierAge = 'INELIGIBLE_EMBRYO_CARRIER_AGE',
  IneligiblePremium = 'INELIGIBLE_PREMIUM',
  NewProducts = 'NEW_PRODUCTS',
  UnsupportedProcedures = 'UNSUPPORTED_PROCEDURES',
}

export type RepresentativeLoanExample = {
  readonly __typename?: 'RepresentativeLoanExample'
  readonly annualInterestRate: Scalars['NonNegativeFloat']
  readonly apr: Scalars['NonNegativeFloat']
  readonly freshRounds: Scalars['Int']
  readonly loanAmount: Scalars['Money']
  readonly months: Scalars['Int']
  readonly payableMonthly: Scalars['Money']
  readonly totalPayable: Scalars['Money']
}

export type RepresentativeRepayment = {
  readonly __typename?: 'RepresentativeRepayment'
  readonly annualInterestRate: Scalars['NonNegativeFloat']
  readonly apr: Scalars['NonNegativeFloat']
  readonly freshRounds: Scalars['NonNegativeInt']
  readonly frozenRounds: Scalars['NonNegativeInt']
  readonly loanAmount: Scalars['Money']
  readonly payableMonthly: Scalars['Money']
  readonly payableMonthlyUncapped: Scalars['Money']
  readonly repaymentMonths: Scalars['NonNegativeInt']
  readonly totalPayable: Scalars['Money']
}

export type RequestOpenBankingLinkError = {
  readonly __typename?: 'RequestOpenBankingLinkError'
  readonly error: Scalars['String']
  readonly ok: Scalars['LiteralFalse']
}

export type RequestOpenBankingLinkOk = {
  readonly __typename?: 'RequestOpenBankingLinkOk'
  readonly ok: Scalars['LiteralTrue']
  readonly value: Scalars['String']
}

export type RequestOpenBankingLinkResult =
  | RequestOpenBankingLinkError
  | RequestOpenBankingLinkOk

export type RequestOwnQuoteInput = {
  readonly clinicId?: InputMaybe<Scalars['ID']>
  readonly contactNumber?: InputMaybe<Scalars['String']>
  readonly partnerEmail?: InputMaybe<Scalars['String']>
  readonly unlistedClinicName?: InputMaybe<Scalars['String']>
}

export type RequestOwnQuoteResponse = {
  readonly __typename?: 'RequestOwnQuoteResponse'
  readonly success: Scalars['Boolean']
}

export enum ResidentialStatus {
  CouncilTenant = 'COUNCIL_TENANT',
  HomeOwnerNoMortgage = 'HOME_OWNER_NO_MORTGAGE',
  HomeOwnerWithMortgage = 'HOME_OWNER_WITH_MORTGAGE',
  JointOwner = 'JOINT_OWNER',
  LiveWithPartner = 'LIVE_WITH_PARTNER',
  LivingWithFamily = 'LIVING_WITH_FAMILY',
  LivingWithParents = 'LIVING_WITH_PARENTS',
  Other = 'OTHER',
  Rent = 'RENT',
  TenantFurnished = 'TENANT_FURNISHED',
  TenantUnfurnished = 'TENANT_UNFURNISHED',
}

export enum RiskIndividualRole {
  Guarantor = 'GUARANTOR',
  Partner = 'PARTNER',
  Self = 'SELF',
}

export enum RiskOutcome {
  Fail = 'FAIL',
  Pass = 'PASS',
}

export type Round = {
  readonly __typename?: 'Round'
  readonly cp: Scalars['Float']
  readonly periodLength: Scalars['Int']
  readonly pr: Scalars['Float']
}

export type SaveCreditProfileError = {
  readonly __typename?: 'SaveCreditProfileError'
  readonly error: Scalars['String']
  readonly ok: Scalars['LiteralFalse']
}

export type SaveCreditProfileOk = {
  readonly __typename?: 'SaveCreditProfileOk'
  readonly ok: Scalars['LiteralTrue']
  readonly value: CreditProfile
}

export type SaveCreditProfileResult =
  | SaveCreditProfileError
  | SaveCreditProfileOk

export type SetCreditProfileOpenBankingConnectedError = {
  readonly __typename?: 'SetCreditProfileOpenBankingConnectedError'
  readonly error: Scalars['String']
  readonly ok: Scalars['LiteralFalse']
}

export type SetCreditProfileOpenBankingConnectedOk = {
  readonly __typename?: 'SetCreditProfileOpenBankingConnectedOk'
  readonly ok: Scalars['LiteralTrue']
  readonly value: CreditProfile
}

export type SetCreditProfileOpenBankingConnectedResult =
  | SetCreditProfileOpenBankingConnectedError
  | SetCreditProfileOpenBankingConnectedOk

/**
 * Steps they still need to complete to get started
 */
export enum StepLeftToComplete {
  DontKnow = 'DONT_KNOW',
  FertilityAssessment = 'FERTILITY_ASSESSMENT',
  FindClinic = 'FIND_CLINIC',
  GetDonor = 'GET_DONOR',
  GetInsured = 'GET_INSURED',
  PlanFinances = 'PLAN_FINANCES',
  WaitForNhs = 'WAIT_FOR_NHS',
  WaitForRightTime = 'WAIT_FOR_RIGHT_TIME',
}

export type TrackPlanQuoteViewError = {
  readonly __typename?: 'TrackPlanQuoteViewError'
  readonly error: Scalars['String']
  readonly ok: Scalars['LiteralFalse']
}

export type TrackPlanQuoteViewOk = {
  readonly __typename?: 'TrackPlanQuoteViewOk'
  readonly ok: Scalars['LiteralTrue']
  readonly value: Scalars['Boolean']
}

export type TrackPlanQuoteViewResult =
  | TrackPlanQuoteViewError
  | TrackPlanQuoteViewOk

/**
 * An input type allowing users to incrementally update their treatment
 * profile with health info
 */
export type TreatmentHealthInput = {
  readonly knowsAmh: Scalars['Boolean']
  /**
   * Has the patient has previously undergone pre-implantation genetic
   * diagnosis?
   */
  readonly previousPgd?: InputMaybe<Scalars['Boolean']>
  /**
   * Who will provide the egg which will be fertilised to produce an
   * embryo to store or transfer?
   */
  readonly roleEggProvider: PathwayIndividualInput
  /**
   * Who is the current user/member and their details for this pathway?
   */
  readonly roleMember: PathwayIndividualInput
  /**
   * Who is considered the partner in the pathway relationship?
   */
  readonly rolePartner: PathwayIndividualInput
}

/**
 * An input type allowing users to incrementally update their treatment
 * profile with history info
 */
export type TreatmentHistoryInput = {
  readonly previousIvf: Scalars['Boolean']
}

/**
 * An input type allowing users to incrementally update their treatment
 * profile with ivf specific history
 */
export type TreatmentIvfHistoryInput = {
  /**
   * The age of the blastocycst at the point of transfer, in the
   * patient's most recent IVF round
   */
  readonly blastocystAge?: InputMaybe<Scalars['NonNegativeInt']>
  /**
   * The number of embryos that were stored for future use, in the
   * patient's most recent IVF round
   */
  readonly embryosStored?: InputMaybe<Scalars['PositiveInt']>
  readonly hasEmbryosStored: Scalars['Boolean']
  /**
   * Has the patient through IVF, achieved a live birth before?
   */
  readonly haveAchievedIvfLiveBirthPreviously?: InputMaybe<Scalars['Boolean']>
  /**
   * Has the patient, naturally or artificially, achieved a live birth
   * before?
   */
  readonly haveAchievedLiveBirthPreviously: Scalars['Boolean']
  /**
   * The number of embryos transferred to the uterus, in the patient's
   * most recent fresh IVF round
   */
  readonly lastEmbryosTransferred?: InputMaybe<Scalars['NonNegativeInt']>
  /**
   * The number of eggs collected from the egg provider in the most
   * recent fresh IVF round
   */
  readonly lastFreshEggsCollected?: InputMaybe<Scalars['NonNegativeInt']>
  /**
   * The number of eggs to successfully develop into an embryo, in the
   * patient's most recent fresh IVF round
   */
  readonly lastFreshEmbryosCreated?: InputMaybe<Scalars['NonNegativeInt']>
  /**
   * The type of transfer in the patient's most recent IVF round (fresh
   * or frozen)
   */
  readonly lastTransferType?: InputMaybe<EmbryoTransferType>
  readonly previousIvf: Scalars['Boolean']
  /**
   * The number of IVF rounds at which the patient achieved live birth
   * through IVF
   */
  readonly previousIvfRoundResultingInLiveBirth?: InputMaybe<
    Scalars['PositiveInt']
  >
  /**
   * The number of IVF rounds the patient has undergone as part of the
   * current attempt at conception
   */
  readonly previousIvfRounds: Scalars['PositiveInt']
  /**
   * A list of the 'add-on' procedures the user used within a previous
   * IVF cycle
   */
  readonly previousProcedures: ReadonlyArray<IvfProcedure>
}

/**
 * An input type allowing users to incrementally update their treatment
 * profile with journey information
 */
export type TreatmentJourneyInput = {
  /**
   * The time the user has spent trying to conceive naturally, without
   * success
   */
  readonly attemptedConceptionFor?: InputMaybe<AttemptedConceptionPeriod>
  /**
   * A list of the user's diagnosed fertility diseases
   */
  readonly diagnoses: ReadonlyArray<FertilityDiagnosis>
  /**
   * What additional textual information has the user provided about
   * their diagnosis? Typically for OTHER
   */
  readonly diagnosesDescription?: InputMaybe<Scalars['String']>
  /**
   * Denotes whether or not the user has any known fertility diagnoses.
   */
  readonly diagnosesStatement?: InputMaybe<UserResponse>
  /**
   * Are eggs historically frozen by the member to use in a potential
   * treatment?
   */
  readonly eggsStored?: InputMaybe<Scalars['Boolean']>
  /**
   * How old was the patient when stored eggs were collected?
   */
  readonly eggsStoredAge?: InputMaybe<Scalars['NonNegativeInt']>
  /**
   * A list of the 'add-on' procedures the user requires in addition to
   * standard IVF which are explicitly selected by the user eg ICSI,
   * excluding those implied eg SpermDonation
   */
  readonly explicitProcedures: ReadonlyArray<ExplicitIvfProcedure>
  /**
   * Has the patient, naturally or artificially, achieved a live birth
   * before?
   */
  readonly haveAchievedLiveBirthPreviously: Scalars['Boolean']
  /**
   * How many eggs are frozen by the member to use in a potential
   * treatment?
   */
  readonly numEggsStored?: InputMaybe<Scalars['NonNegativeInt']>
  readonly previousLiveBirthsCount?: InputMaybe<Scalars['Int']>
  readonly previousPregnanciesCount?: InputMaybe<Scalars['Int']>
  /**
   * Who will provide the egg which will be fertilised to produce an
   * embryo to store or transfer?
   */
  readonly roleEggProvider: PathwayIndividualInput
  /**
   * Who will be the recipient of an embryo transfer, potentially go
   * through pregnancy and give birth?
   */
  readonly roleEmbryoCarrier: PathwayIndividualInput
  /**
   * Who is the current user/member and their details for this pathway?
   */
  readonly roleMember: PathwayIndividualInput
  /**
   * Who is considered the partner in the pathway relationship?
   */
  readonly rolePartner: PathwayIndividualInput
  /**
   * Who will provide the sperm which will be used to fertilise the egg?
   */
  readonly roleSpermProvider: PathwayIndividualInput
}

/**
 * The result of a prediction given specific treatment pathway input
 */
export type TreatmentPrediction = {
  readonly __typename?: 'TreatmentPrediction'
  readonly cumulativeProbabilities: ReadonlyArray<Scalars['Float']>
  readonly displayRoundIndex: Scalars['Int']
  readonly error?: Maybe<ReadonlyArray<PredictionError>>
  readonly modelID: Scalars['NonEmptyString']
  readonly modelType: Scalars['NonEmptyString']
  readonly referenceValues: ReadonlyArray<Scalars['Float']>
  readonly status: PathwayPredictionStatus
}

/**
 * A representation of the user's treatment profile, with their most
 * recent treatment pathway
 */
export type TreatmentProfile = {
  readonly __typename?: 'TreatmentProfile'
  readonly embryosStored?: Maybe<Scalars['Int']>
  /**
   * Globally unique profile id
   */
  readonly id?: Maybe<Scalars['ID']>
  /**
   * The user's treatment profile information
   */
  readonly inputs?: Maybe<TreatmentProfileInputs>
  /**
   * The cumulative probabilities of live birth at each round
   */
  readonly prediction?: Maybe<TreatmentPrediction>
  readonly rolePartner?: Maybe<PathwayIndividual>
  /**
   * How much of their treatment profile has the user filled out?
   */
  readonly status: TreatmentProfileStatus
}

/**
 * A container for _all_ the user's treatment profile information - this
 * is typically a subset of each profile section input such as
 * TreatmentHealthInput, TreatmentJourneyInput, etc.
 */
export type TreatmentProfileInputs = {
  readonly __typename?: 'TreatmentProfileInputs'
  /**
   * The time the user has spent trying to conceive naturally, without
   * success
   *
   * @deprecated No longer ask this question
   */
  readonly attemptedConceptionFor?: Maybe<AttemptedConceptionPeriod>
  /**
   * The age of the blastocycst at the point of transfer, in the
   * patient's most recent IVF round
   */
  readonly blastocystAge?: Maybe<Scalars['NonNegativeInt']>
  /**
   * A list of the user's diagnosed fertility diseases
   */
  readonly diagnoses: ReadonlyArray<FertilityDiagnosis>
  /**
   * What additional textual information has the user provided about
   * their diagnosis? Typically for OTHER
   */
  readonly diagnosesDescription?: Maybe<Scalars['String']>
  /**
   * Denotes whether or not the user has any known fertility diagnoses.
   */
  readonly diagnosesStatement?: Maybe<UserResponse>
  /**
   * Are eggs historically frozen by the member to use in a potential
   * treatment?
   */
  readonly eggsStored?: Maybe<Scalars['Boolean']>
  /**
   * How old was the patient when stored eggs were collected?
   */
  readonly eggsStoredAge?: Maybe<Scalars['NonNegativeInt']>
  /**
   * The number of embryos that were stored for future use, in the
   * patient's most recent IVF round
   */
  readonly embryosStored?: Maybe<Scalars['NonNegativeInt']>
  /**
   * A list of the 'add-on' procedures the user requires in addition to
   * standard IVF which are explicitly selected by the user eg ICSI,
   * excluding those implied eg SpermDonation
   */
  readonly explicitProcedures?: Maybe<ReadonlyArray<ExplicitIvfProcedure>>
  /**
   * Is there anything else we should know?
   */
  readonly extraInformationFromUser?: Maybe<Scalars['String']>
  /**
   * Has the user indicated they have embryos stored?
   */
  readonly hasEmbryosStored?: Maybe<Scalars['Boolean']>
  /**
   * Has the patient through IVF, achieved a live birth before?
   */
  readonly haveAchievedIvfLiveBirthPreviously?: Maybe<Scalars['Boolean']>
  /**
   * Has the patient, naturally or artificially, achieved a live birth
   * before?
   */
  readonly haveAchievedLiveBirthPreviously?: Maybe<Scalars['Boolean']>
  /**
   * What period of time intend to start IVF within
   */
  readonly intendedStartPeriod?: Maybe<IntendedStartPeriod>
  /**
   * Not persisted - client flag
   */
  readonly knowsAmh?: Maybe<Scalars['Boolean']>
  /**
   * The number of embryos transferred to the uterus, in the patient's
   * most recent fresh IVF round
   */
  readonly lastEmbryosTransferred?: Maybe<Scalars['NonNegativeInt']>
  /**
   * The number of eggs collected from the egg provider in the most
   * recent fresh IVF round
   */
  readonly lastFreshEggsCollected?: Maybe<Scalars['NonNegativeInt']>
  /**
   * The number of eggs to successfully develop into an embryo, in the
   * patient's most recent fresh IVF round
   */
  readonly lastFreshEmbryosCreated?: Maybe<Scalars['NonNegativeInt']>
  /**
   * The type of transfer in the patient's most recent IVF round (fresh
   * or frozen)
   */
  readonly lastTransferType?: Maybe<EmbryoTransferType>
  /**
   * Are they eligible for nhs funding?
   *
   * @deprecated No longer ask this question
   */
  readonly nhsFundingEligibility?: Maybe<NhsFundingEligibility>
  /**
   * How many eggs are frozen by the member to use in a potential
   * treatment?
   */
  readonly numEggsStored?: Maybe<Scalars['NonNegativeInt']>
  /**
   * What types of consultations have they already had?
   */
  readonly previousConsultations: ReadonlyArray<ConsultationType>
  /**
   * Has the user had IVF before?
   */
  readonly previousIvf?: Maybe<Scalars['Boolean']>
  /**
   * The number of IVF rounds at which the patient achieved live birth
   * through IVF
   */
  readonly previousIvfRoundResultingInLiveBirth?: Maybe<
    Scalars['NonNegativeInt']
  >
  /**
   * The number of IVF rounds the patient has undergone as part of the
   * current attempt at conception
   */
  readonly previousIvfRounds?: Maybe<Scalars['NonNegativeInt']>
  readonly previousLiveBirthsCount?: Maybe<Scalars['Int']>
  /**
   * How many miscarriages has the patient suffered?
   *
   * @deprecated No longer ask this question
   */
  readonly previousMiscarriages?: Maybe<Scalars['NonNegativeInt']>
  /**
   * Has the patient has previously undergone pre-implantation genetic
   * diagnosis?
   *
   * @deprecated No longer ask this question
   */
  readonly previousPgd?: Maybe<Scalars['Boolean']>
  readonly previousPregnanciesCount?: Maybe<Scalars['Int']>
  /**
   * A list of the 'add-on' procedures the user used within a previous
   * IVF cycle
   */
  readonly previousProcedures: ReadonlyArray<IvfProcedure>
  /**
   * A list of the 'add-on' procedures the user requires in addition to
   * standard IVF
   */
  readonly procedures: ReadonlyArray<IvfProcedure>
  /**
   * Who will provide the egg which will be fertilised to produce an
   * embryo to store or transfer?
   */
  readonly roleEggProvider: PathwayIndividual
  /**
   * Who will be the recipient of an embryo transfer, potentially go
   * through pregnancy and give birth?
   */
  readonly roleEmbryoCarrier: PathwayIndividual
  /**
   * Who is the current user/member and their details for this pathway?
   */
  readonly roleMember: PathwayIndividual
  /**
   * Who is considered the partner in the pathway relationship?
   */
  readonly rolePartner: PathwayIndividual
  /**
   * Who will provide the sperm which will be used to fertilise the egg?
   */
  readonly roleSpermProvider: PathwayIndividual
}

/**
 * The current state of progress of the user's treatment profile
 */
export enum TreatmentProfileStatus {
  /**
   * If all user inputs are available we consider the profile complete
   */
  Complete = 'COMPLETE',
  /**
   * When no inputs are available
   */
  NotStarted = 'NOT_STARTED',
  /**
   * When some inputs are available
   */
  PartiallyComplete = 'PARTIALLY_COMPLETE',
}

export type TreatmentProofDocument = {
  readonly __typename?: 'TreatmentProofDocument'
  readonly createdAt: Scalars['DateTime']
  readonly deletedAt?: Maybe<Scalars['DateTime']>
  readonly documentUrn: Scalars['String']
  readonly id: Scalars['ID']
  readonly updatedAt: Scalars['DateTime']
  readonly userId: Scalars['ID']
}

/**
 * An input type allowing users or ops to update the treatment profile
 * in its entirety
 */
export type TreatmentWholeInput = {
  /**
   * The age of the blastocycst at the point of transfer, in the
   * patient's most recent IVF round
   */
  readonly blastocystAge?: InputMaybe<Scalars['NonNegativeInt']>
  /**
   * A list of the user's diagnosed fertility diseases
   */
  readonly diagnoses: ReadonlyArray<FertilityDiagnosis>
  /**
   * What additional textual information has the user provided about
   * their diagnosis? Typically for OTHER
   */
  readonly diagnosesDescription?: InputMaybe<Scalars['String']>
  /**
   * Are eggs historically frozen by the member to use in a potential
   * treatment?
   */
  readonly eggsStored?: InputMaybe<Scalars['Boolean']>
  /**
   * How old was the patient when stored eggs were collected?
   */
  readonly eggsStoredAge?: InputMaybe<Scalars['NonNegativeInt']>
  /**
   * The number of embryos that were stored for future use, in the
   * patient's most recent IVF round
   */
  readonly embryosStored?: InputMaybe<Scalars['NonNegativeInt']>
  /**
   * A list of the 'add-on' procedures the user requires in addition to
   * standard IVF
   */
  readonly explicitProcedures: ReadonlyArray<ExplicitIvfProcedure>
  /**
   * Is there anything else we should know?
   */
  readonly extraInformationFromUser?: InputMaybe<Scalars['String']>
  /**
   * Has the user indicated they have embryos stored?
   */
  readonly hasEmbryosStored?: InputMaybe<Scalars['Boolean']>
  /**
   * Has the patient through IVF, achieved a live birth before?
   */
  readonly haveAchievedIvfLiveBirthPreviously?: InputMaybe<Scalars['Boolean']>
  /**
   * Has the patient, naturally or artificially, achieved a live birth
   * before?
   */
  readonly haveAchievedLiveBirthPreviously: Scalars['Boolean']
  /**
   * What period of time intend to start IVF within
   */
  readonly intendedStartPeriod?: InputMaybe<IntendedStartPeriod>
  /**
   * Not persisted - client flag
   */
  readonly knowsAmh: Scalars['Boolean']
  /**
   * The number of embryos transferred to the uterus, in the patient's
   * most recent fresh IVF round
   */
  readonly lastEmbryosTransferred?: InputMaybe<Scalars['NonNegativeInt']>
  /**
   * The number of eggs collected from the egg provider in the most
   * recent fresh IVF round
   */
  readonly lastFreshEggsCollected?: InputMaybe<Scalars['NonNegativeInt']>
  /**
   * The number of eggs to successfully develop into an embryo, in the
   * patient's most recent fresh IVF round
   */
  readonly lastFreshEmbryosCreated?: InputMaybe<Scalars['NonNegativeInt']>
  /**
   * The type of transfer in the patient's most recent IVF round (fresh
   * or frozen)
   */
  readonly lastTransferType?: InputMaybe<EmbryoTransferType>
  /**
   * Are they eligible for NHS funding?
   */
  readonly nhsFundingEligibility?: InputMaybe<NhsFundingEligibility>
  /**
   * How many eggs are frozen by the member to use in a potential
   * treatment?
   */
  readonly numEggsStored?: InputMaybe<Scalars['NonNegativeInt']>
  /**
   * What types of consultations have they already had?
   */
  readonly previousConsultations: ReadonlyArray<ConsultationType>
  /**
   * Has the user had IVF before?
   */
  readonly previousIvf: Scalars['Boolean']
  /**
   * The number of IVF rounds at which the patient achieved live birth
   * through IVF
   */
  readonly previousIvfRoundResultingInLiveBirth?: InputMaybe<
    Scalars['NonNegativeInt']
  >
  /**
   * The number of IVF rounds the patient has undergone as part of the
   * current attempt at conception
   */
  readonly previousIvfRounds?: InputMaybe<Scalars['NonNegativeInt']>
  readonly previousLiveBirthsCount?: InputMaybe<Scalars['Int']>
  readonly previousPregnanciesCount?: InputMaybe<Scalars['Int']>
  /**
   * A list of the 'add-on' procedures the user used within a previous
   * IVF cycle
   */
  readonly previousProcedures?: InputMaybe<ReadonlyArray<IvfProcedure>>
  /**
   * Who will provide the egg which will be fertilised to produce an
   * embryo to store or transfer?
   */
  readonly roleEggProvider: PathwayIndividualInput
  /**
   * Who will be the recipient of an embryo transfer, potentially go
   * through pregnancy and give birth?
   */
  readonly roleEmbryoCarrier: PathwayIndividualInput
  /**
   * Who is the current user/member and their details for this pathway?
   */
  readonly roleMember: PathwayIndividualInput
  /**
   * Who is considered the partner in the pathway relationship?
   */
  readonly rolePartner: PathwayIndividualInput
  /**
   * Who will provide the sperm which will be used to fertilise the egg?
   */
  readonly roleSpermProvider: PathwayIndividualInput
}

/**
 * Amount willing to pay upfront for IVF
 */
export enum UpfrontPayment {
  EightThousandToFifteenThousand = 'EIGHT_THOUSAND_TO_FIFTEEN_THOUSAND',
  LessThanOneThousand = 'LESS_THAN_ONE_THOUSAND',
  MoreThanFifteenThousand = 'MORE_THAN_FIFTEEN_THOUSAND',
  OneThousandToThreeThousand = 'ONE_THOUSAND_TO_THREE_THOUSAND',
  Other = 'OTHER',
  ThreeThousandToEightThousand = 'THREE_THOUSAND_TO_EIGHT_THOUSAND',
}

export type UploadTreatmentProofDocumentError = {
  readonly __typename?: 'UploadTreatmentProofDocumentError'
  readonly error: Scalars['String']
  readonly ok: Scalars['LiteralFalse']
}

export type UploadTreatmentProofDocumentOk = {
  readonly __typename?: 'UploadTreatmentProofDocumentOk'
  readonly ok: Scalars['LiteralTrue']
  readonly value: TreatmentProofDocument
}

export type UploadTreatmentProofDocumentResult =
  | UploadTreatmentProofDocumentError
  | UploadTreatmentProofDocumentOk

export type UsCreditProfile = CreditProfile & {
  readonly __typename?: 'UsCreditProfile'
  readonly address: UsCreditProfileAddress
  readonly country: Country
  readonly dateOfBirth: Scalars['Date']
  readonly dependents: Scalars['Int']
  readonly email: Scalars['EmailAddress']
  readonly employmentStatus: EmploymentStatus
  readonly firstName: Scalars['NonEmptyString']
  readonly grossAnnualIncome: Scalars['Money']
  readonly id: Scalars['ID']
  readonly individual: RiskIndividualRole
  readonly lastName: Scalars['NonEmptyString']
  readonly monthlyExpenses: Scalars['Money']
  readonly monthlyRentOrMortgage: Scalars['Money']
  readonly namePrefix: Scalars['NonEmptyString']
  readonly residentialStatus: ResidentialStatus
  readonly socialSecurityNumber: Scalars['String']
}

export type UsCreditProfileAddress = {
  readonly __typename?: 'UsCreditProfileAddress'
  readonly city: Scalars['String']
  readonly countryCode: Country
  readonly line1: Scalars['String']
  readonly line2?: Maybe<Scalars['String']>
  readonly moveInDate: Scalars['Date']
  readonly postcode: Scalars['String']
  readonly residentialStatus?: Maybe<ResidentialStatus>
  readonly source?: Maybe<AddressSource>
  readonly state: Scalars['String']
}

export type UsCreditProfileAddressInput = {
  readonly city: Scalars['NonEmptyString']
  readonly countryCode: Country
  readonly line1: Scalars['NonEmptyString']
  readonly line2?: InputMaybe<Scalars['NonEmptyString']>
  readonly moveInDate: Scalars['Date']
  readonly postcode: Scalars['NonEmptyString']
  readonly residentialStatus?: InputMaybe<ResidentialStatus>
  readonly source?: InputMaybe<AddressSource>
  readonly state: Scalars['NonEmptyString']
}

export type UsCreditProfileInput = {
  readonly address: UsCreditProfileAddressInput
  readonly country: Country
  readonly dateOfBirth: Scalars['Date']
  readonly dependents: Scalars['Int']
  readonly email: Scalars['EmailAddress']
  readonly employmentStatus: EmploymentStatus
  readonly firstName: Scalars['NonEmptyString']
  readonly grossAnnualIncome: Scalars['Money']
  readonly individual: RiskIndividualRole
  readonly lastName: Scalars['NonEmptyString']
  readonly monthlyExpenses?: InputMaybe<Scalars['Money']>
  readonly monthlyRentOrMortgage: Scalars['Money']
  readonly namePrefix: Scalars['NonEmptyString']
  readonly residentialStatus: ResidentialStatus
  readonly socialSecurityNumber: Scalars['String']
  readonly userId: Scalars['ID']
}

export enum UsaState {
  Ct = 'CT',
  NotApplicable = 'NOT_APPLICABLE',
  Va = 'VA',
}

export type User = {
  readonly __typename?: 'User'
  readonly activeCreditApplication?: Maybe<CreditApplication>
  /**
   * Address of the user
   */
  readonly address?: Maybe<Address>
  /**
   * Age of the user, computed from supplied date of birth
   */
  readonly age?: Maybe<Scalars['Int']>
  /**
   * Contact number of the user
   */
  readonly contactNumber?: Maybe<Scalars['String']>
  readonly country: Country
  readonly createdAt: Scalars['DateTime']
  /**
   * @deprecated Field no longer supported
   */
  readonly creditApplications: ReadonlyArray<CreditApplication>
  /**
   * The user's date of birth
   */
  readonly dateOfBirth?: Maybe<Scalars['Date']>
  readonly email: Scalars['EmailAddress']
  /**
   * Has the user verified their email address?
   */
  readonly emailVerified: Scalars['Boolean']
  readonly firstName?: Maybe<Scalars['String']>
  /**
   * Gender identity of the user
   */
  readonly gender?: Maybe<Gender>
  /**
   * A title for the user's gender identity (if they have selected
   * Other)
   */
  readonly genderTitle?: Maybe<Scalars['String']>
  /**
   * Has the user had an initial diagnostic test
   *
   * @deprecated Indicated by intendedStartPeriod instead
   */
  readonly hadInitialDiagnosticTest?: Maybe<Scalars['Boolean']>
  readonly hasPartner?: Maybe<Scalars['Boolean']>
  readonly healthInsuranceCoverage: ReadonlyArray<HealthInsuranceCoverage>
  readonly hubspotToken?: Maybe<Scalars['String']>
  readonly id: Scalars['ID']
  /**
   * What period of time intend to start IVF within
   */
  readonly intendedStartPeriod?: Maybe<IntendedStartPeriod>
  readonly isLeto: Scalars['Boolean']
  /**
   * Is the user ready to start ivf?
   *
   * @deprecated Indicated by intendedStartPeriod instead
   */
  readonly isReadyToStartIVF?: Maybe<Scalars['Boolean']>
  /**
   * UX Overhaul feature flag
   */
  readonly isUxOverhaul?: Maybe<Scalars['Boolean']>
  /**
   * Is this user the current viewer?
   */
  readonly isViewer?: Maybe<Scalars['Boolean']>
  /**
   * Stage in IVF journey
   *
   * @deprecated Indicated by intendedStartPeriod instead
   */
  readonly ivfJourneyStage?: Maybe<IvfJourneyStage>
  readonly lastName?: Maybe<Scalars['String']>
  readonly latestCreditProfile?: Maybe<CreditProfile>
  /**
   * What is the next step the user needs to complete
   */
  readonly nextGaiaStep: NextGaiaStep
  /**
   * Free text for amount willing to pay upfront for IVF if selected
   * other
   *
   * @deprecated Past experiment, no longer needed
   */
  readonly otherUpfrontPaymentPreference?: Maybe<Scalars['String']>
  readonly partnerEmail?: Maybe<Scalars['String']>
  readonly partnerFirstName?: Maybe<Scalars['String']>
  readonly partnerLastName?: Maybe<Scalars['String']>
  /**
   * Available quotes for a user
   */
  readonly planQuotes: ReadonlyArray<PlanQuote>
  /**
   * Available quoteCollections for a user
   */
  readonly quoteCollections: ReadonlyArray<QuoteCollection>
  /**
   * Active requests made by this user
   */
  readonly quoteRequests: ReadonlyArray<QuoteRequest>
  /**
   * Code to use in referral links
   */
  readonly referralCode?: Maybe<Scalars['String']>
  /**
   * Id of user who referred them
   */
  readonly referredByUserId?: Maybe<Scalars['String']>
  /**
   * Clinic who referred the user
   */
  readonly referrerClinicId?: Maybe<Scalars['ID']>
  /**
   * Reason why the user is currently rejected
   */
  readonly rejection?: Maybe<Rejection>
  /**
   * What steps do they still need to complete to get started?
   *
   * @deprecated No longer ask this question
   */
  readonly stepsLeftToComplete?: Maybe<ReadonlyArray<StepLeftToComplete>>
  readonly tags: ReadonlyArray<Scalars['String']>
  /**
   * The user's treatment profile
   */
  readonly treatmentProfile?: Maybe<TreatmentProfile>
  /**
   * All treatment proof documents uploaded
   */
  readonly treatmentProofDocumentList: ReadonlyArray<TreatmentProofDocument>
  /**
   * Unlisted clinic name who referred the user
   */
  readonly unlistedReferrerClinicName?: Maybe<Scalars['String']>
  /**
   * Amount willing to pay upfront for IVF
   *
   * @deprecated Past experiment, no longer needed
   */
  readonly upfrontPaymentPreference?: Maybe<UpfrontPayment>
  readonly usaState: UsaState
}

export type UserLatestCreditProfileArgs = {
  individual: RiskIndividualRole
}

export type UserPlanQuotesArgs = {
  filters?: InputMaybe<PlanQuotesFiltersInput>
}

export type UserQuoteCollectionsArgs = {
  filters?: InputMaybe<QuoteCollectionsFiltersInput>
}

export enum UserResponse {
  No = 'NO',
  NotSure = 'NOT_SURE',
  Yes = 'YES',
}

/**
 * Input representation of the user's information
 */
export type UserUpdateInput = {
  readonly contactNumber?: InputMaybe<Scalars['String']>
  readonly dateOfBirth?: InputMaybe<Scalars['Date']>
  readonly firstName?: InputMaybe<Scalars['NonEmptyString']>
  readonly gender?: InputMaybe<Gender>
  readonly genderTitle?: InputMaybe<Scalars['NonEmptyString']>
  readonly lastName?: InputMaybe<Scalars['NonEmptyString']>
  readonly partnerEmail?: InputMaybe<Scalars['String']>
}

export type UtmInput = {
  readonly campaign?: InputMaybe<Scalars['String']>
  readonly content?: InputMaybe<Scalars['String']>
  readonly medium?: InputMaybe<Scalars['String']>
  readonly source?: InputMaybe<Scalars['String']>
  readonly term?: InputMaybe<Scalars['String']>
}

export enum VerificationStatus {
  Completed = 'COMPLETED',
  Todo = 'TODO',
}

/**
 * A viewer type representing an authenticated viewer of a request
 */
export type Viewer = {
  readonly __typename?: 'Viewer'
  /**
   * Whether the current viewer should be able to see predictions or not
   */
  readonly canViewPredictions: Scalars['Boolean']
  /**
   * An email name associated with the current viewer
   */
  readonly email?: Maybe<Scalars['EmailAddress']>
  /**
   * A name associated with the current viewer
   */
  readonly firstName?: Maybe<Scalars['String']>
  /**
   * A persistent identifier for this viewer (user.id if authenticated,
   * session.id if not)
   */
  readonly id: Scalars['ID']
  readonly lastName?: Maybe<Scalars['String']>
  /**
   * A user associated with the current viewer. If a user IS associated
   * with the viewer then this implies they are authenticated
   */
  readonly user?: Maybe<User>
}

export type UploadDocumentInput = {
  readonly documentUrn: Scalars['String']
  readonly userId: Scalars['ID']
}

export type NavigationQueryVariables = Exact<{ [key: string]: never }>

export type NavigationQuery = {
  readonly __typename?: 'Query'
  readonly viewer: {
    readonly __typename?: 'Viewer'
    readonly user?: {
      readonly __typename?: 'User'
      readonly treatmentProfile?: {
        readonly __typename?: 'TreatmentProfile'
        readonly status: TreatmentProfileStatus
      } | null
      readonly treatmentProofDocumentList: ReadonlyArray<{
        readonly __typename?: 'TreatmentProofDocument'
        readonly id: string
      }>
    } | null
  }
}

export type MeQueryVariables = Exact<{ [key: string]: never }>

export type MeQuery = {
  readonly __typename?: 'Query'
  readonly me: {
    readonly __typename?: 'Viewer'
    readonly id: string
    readonly user?: {
      readonly __typename?: 'User'
      readonly id: string
      readonly firstName?: string | null
      readonly lastName?: string | null
      readonly isUxOverhaul?: boolean | null
    } | null
  }
}

export type ClinicsQueryVariables = Exact<{
  country?: InputMaybe<Country>
}>

export type ClinicsQuery = {
  readonly __typename?: 'Query'
  readonly clinics?: {
    readonly __typename?: 'ClinicsPaged'
    readonly data: ReadonlyArray<{
      readonly __typename?: 'Clinic'
      readonly id: string
      readonly name: string
      readonly usaState: UsaState
    }>
  } | null
}

export type AccountQueryVariables = Exact<{ [key: string]: never }>

export type AccountQuery = {
  readonly __typename?: 'Query'
  readonly viewer: {
    readonly __typename?: 'Viewer'
    readonly id: string
    readonly user?: {
      readonly __typename?: 'User'
      readonly id: string
      readonly email: string
      readonly firstName?: string | null
      readonly lastName?: string | null
      readonly contactNumber?: string | null
      readonly address?: {
        readonly __typename?: 'Address'
        readonly line1?: string | null
        readonly line2?: string | null
        readonly city?: string | null
        readonly county?: string | null
        readonly country?: string | null
        readonly postcode?: string | null
      } | null
    } | null
  }
}

export type UpdateOwnAddressMutationVariables = Exact<{
  address: AddressInput
}>

export type UpdateOwnAddressMutation = {
  readonly __typename?: 'Mutation'
  readonly updateOwnAddress?: {
    readonly __typename?: 'User'
    readonly address?: {
      readonly __typename?: 'Address'
      readonly line1?: string | null
      readonly line2?: string | null
      readonly postcode?: string | null
      readonly city?: string | null
      readonly county?: string | null
      readonly country?: string | null
    } | null
  } | null
}

export type UpdateOwnEmailAddressMutationVariables = Exact<{
  email: Scalars['EmailAddress']
}>

export type UpdateOwnEmailAddressMutation = {
  readonly __typename?: 'Mutation'
  readonly updateOwnEmailAddress?: {
    readonly __typename?: 'User'
    readonly id: string
    readonly email: string
  } | null
}

export type UpdateOwnPasswordMutationVariables = Exact<{
  currentPassword: Scalars['String']
  newPassword: Scalars['String']
}>

export type UpdateOwnPasswordMutation = {
  readonly __typename?: 'Mutation'
  readonly updateOwnPassword?: boolean | null
}

export type UpdateOwnPersonalInformationMutationVariables = Exact<{
  info: UserUpdateInput
}>

export type UpdateOwnPersonalInformationMutation = {
  readonly __typename?: 'Mutation'
  readonly updateSelf?: {
    readonly __typename?: 'User'
    readonly contactNumber?: string | null
    readonly firstName?: string | null
    readonly lastName?: string | null
  } | null
}

export type ActiveCreditApplicationQueryVariables = Exact<{
  [key: string]: never
}>

export type ActiveCreditApplicationQuery = {
  readonly __typename?: 'Query'
  readonly viewer: {
    readonly __typename?: 'Viewer'
    readonly id: string
    readonly user?: {
      readonly __typename?: 'User'
      readonly id: string
      readonly activeCreditApplication?: {
        readonly __typename?: 'CreditApplication'
        readonly id: string
        readonly status: CreditApplicationStatus
      } | null
    } | null
  }
}

export type CreateCreditApplicationMutationVariables = Exact<{
  individuals: ReadonlyArray<RiskIndividualRole> | RiskIndividualRole
}>

export type CreateCreditApplicationMutation = {
  readonly __typename?: 'Mutation'
  readonly createCreditApplication:
    | {
        readonly __typename?: 'CreateCreditApplicationError'
        readonly error: string
      }
    | {
        readonly __typename?: 'CreateCreditApplicationOk'
        readonly value: boolean
      }
}

export type LatestCreditProfileQueryVariables = Exact<{
  individual: RiskIndividualRole
}>

export type LatestCreditProfileQuery = {
  readonly __typename?: 'Query'
  readonly viewer: {
    readonly __typename?: 'Viewer'
    readonly id: string
    readonly user?: {
      readonly __typename?: 'User'
      readonly id: string
      readonly firstName?: string | null
      readonly lastName?: string | null
      readonly dateOfBirth?: string | null
      readonly email: string
      readonly partnerFirstName?: string | null
      readonly partnerLastName?: string | null
      readonly partnerEmail?: string | null
      readonly hasPartner?: boolean | null
      readonly treatmentProfile?: {
        readonly __typename?: 'TreatmentProfile'
        readonly inputs?: {
          readonly __typename?: 'TreatmentProfileInputs'
          readonly roleMember: {
            readonly __typename?: 'PathwayIndividual'
            readonly dateOfBirth?: string | null
          }
          readonly rolePartner: {
            readonly __typename?: 'PathwayIndividual'
            readonly dateOfBirth?: string | null
            readonly sex: IndividualSex
          }
        } | null
      } | null
      readonly latestCreditProfile?:
        | {
            readonly __typename: 'GbCreditProfile'
            readonly id: string
            readonly namePrefix: string
            readonly firstName: string
            readonly lastName: string
            readonly dateOfBirth: string
            readonly email: string
            readonly employmentStatus: EmploymentStatus
            readonly grossAnnualIncome: Gaia.Money
            readonly dependents: number
            readonly monthlyRentOrMortgage: Gaia.Money
            readonly monthlyExpenses: Gaia.Money
            readonly address: {
              readonly __typename?: 'GbCreditProfileAddress'
              readonly street: string
              readonly city: string
              readonly country: string
              readonly houseNumber?: string | null
              readonly houseName?: string | null
              readonly flat?: string | null
              readonly postcode: string
              readonly residentialStatus?: ResidentialStatus | null
              readonly moveInDate: string
              readonly source?: AddressSource | null
            }
            readonly previousAddresses?: ReadonlyArray<{
              readonly __typename?: 'GbCreditProfileAddress'
              readonly street: string
              readonly city: string
              readonly country: string
              readonly houseNumber?: string | null
              readonly houseName?: string | null
              readonly flat?: string | null
              readonly postcode: string
              readonly residentialStatus?: ResidentialStatus | null
              readonly moveInDate: string
              readonly source?: AddressSource | null
            }> | null
          }
        | {
            readonly __typename: 'UsCreditProfile'
            readonly socialSecurityNumber: string
            readonly id: string
            readonly namePrefix: string
            readonly firstName: string
            readonly lastName: string
            readonly dateOfBirth: string
            readonly email: string
            readonly employmentStatus: EmploymentStatus
            readonly grossAnnualIncome: Gaia.Money
            readonly dependents: number
            readonly monthlyRentOrMortgage: Gaia.Money
            readonly monthlyExpenses: Gaia.Money
            readonly address: {
              readonly __typename?: 'UsCreditProfileAddress'
              readonly line1: string
              readonly line2?: string | null
              readonly city: string
              readonly state: string
              readonly postcode: string
              readonly countryCode: Country
              readonly moveInDate: string
              readonly residentialStatus?: ResidentialStatus | null
              readonly source?: AddressSource | null
            }
          }
        | null
    } | null
  }
}

export type SaveCreditProfileMutationVariables = Exact<{
  profile: CreditProfileInput
}>

export type SaveCreditProfileMutation = {
  readonly __typename?: 'Mutation'
  readonly saveCreditProfile:
    | { readonly __typename?: 'SaveCreditProfileError'; readonly error: string }
    | {
        readonly __typename?: 'SaveCreditProfileOk'
        readonly value:
          | { readonly __typename?: 'GbCreditProfile'; readonly id: string }
          | { readonly __typename?: 'UsCreditProfile'; readonly id: string }
      }
}

export type CheckForEmailVerifiedQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>
}>

export type CheckForEmailVerifiedQuery = {
  readonly __typename?: 'Query'
  readonly getUserByEmailOrId: {
    readonly __typename?: 'User'
    readonly emailVerified: boolean
  }
}

export type VerifyEmailAddressMutationVariables = Exact<{
  token: Scalars['String']
}>

export type VerifyEmailAddressMutation = {
  readonly __typename?: 'Mutation'
  readonly verifyEmailAddress?: {
    readonly __typename?: 'User'
    readonly id: string
    readonly emailVerified: boolean
  } | null
}

export type RequestEmailVerificationMutationVariables = Exact<{
  email: Scalars['String']
}>

export type RequestEmailVerificationMutation = {
  readonly __typename?: 'Mutation'
  readonly requestEmailVerification?: boolean | null
}

export type AcceptPlanQuoteMutationVariables = Exact<{
  acceptPlanQuoteInput: AcceptPlanQuoteInput
}>

export type AcceptPlanQuoteMutation = {
  readonly __typename?: 'Mutation'
  readonly acceptPlanQuote:
    | {
        readonly __typename?: 'IoPlanQuote'
        readonly acceptedAt?: string | null
      }
    | {
        readonly __typename?: 'LetoPlanQuote'
        readonly acceptedAt?: string | null
      }
}

export type TrackPlanQuoteViewMutationVariables = Exact<{
  quoteId: Scalars['ID']
}>

export type TrackPlanQuoteViewMutation = {
  readonly __typename?: 'Mutation'
  readonly trackPlanQuoteView:
    | { readonly __typename?: 'TrackPlanQuoteViewError' }
    | { readonly __typename?: 'TrackPlanQuoteViewOk'; readonly ok: true }
}

export type SharedRepresentativeRepaymentFragment = {
  readonly __typename?: 'RepresentativeRepayment'
  readonly freshRounds: number
  readonly frozenRounds: number
  readonly apr: number
  readonly annualInterestRate: number
  readonly repaymentMonths: number
  readonly loanAmount: Gaia.Money
  readonly totalPayable: Gaia.Money
  readonly payableMonthly: Gaia.Money
  readonly payableMonthlyUncapped: Gaia.Money
}

export type GetPlanQuoteQueryVariables = Exact<{
  quoteId: Scalars['ID']
}>

export type GetPlanQuoteQuery = {
  readonly __typename?: 'Query'
  readonly viewer: {
    readonly __typename?: 'Viewer'
    readonly id: string
    readonly user?: {
      readonly __typename?: 'User'
      readonly id: string
      readonly firstName?: string | null
      readonly partnerFirstName?: string | null
      readonly activeCreditApplication?: {
        readonly __typename?: 'CreditApplication'
        readonly status: CreditApplicationStatus
      } | null
      readonly planQuotes: ReadonlyArray<
        | {
            readonly __typename: 'IoPlanQuote'
            readonly monthlyMembershipLiability: Gaia.Money
            readonly roundsCovered: number
            readonly freshPremium?: Gaia.Money | null
            readonly freshLiability: Gaia.Money
            readonly frozenPremium?: Gaia.Money | null
            readonly frozenLiability: Gaia.Money
            readonly maxFinancedFreshRounds?: number | null
            readonly id: string
            readonly variant: PlanProductVariant
            readonly expiresAt: string
            readonly lastViewedAt?: string | null
            readonly repaymentPeriods: number
            readonly annualInterestRate: number
            readonly coverPeriods: number
            readonly firstTreatmentWithinPeriods: number
            readonly procedures: ReadonlyArray<IvfProcedure>
            readonly status: QuoteStatus
            readonly representativeLoanExample?: {
              readonly __typename?: 'RepresentativeLoanExample'
              readonly loanAmount: Gaia.Money
              readonly payableMonthly: Gaia.Money
              readonly totalPayable: Gaia.Money
              readonly months: number
              readonly apr: number
              readonly freshRounds: number
              readonly annualInterestRate: number
            } | null
            readonly representativeRepaymentTable: ReadonlyArray<{
              readonly __typename?: 'RepresentativeRepayment'
              readonly freshRounds: number
              readonly frozenRounds: number
              readonly apr: number
              readonly annualInterestRate: number
              readonly repaymentMonths: number
              readonly loanAmount: Gaia.Money
              readonly totalPayable: Gaia.Money
              readonly payableMonthly: Gaia.Money
              readonly payableMonthlyUncapped: Gaia.Money
            }>
            readonly financePlan?: {
              readonly __typename?: 'FinancePlan'
              readonly id: string
              readonly annualInterestRate: number
              readonly apr: number
              readonly repaymentPeriodInMonths: number
              readonly maxFinancedLiability: Gaia.Money
              readonly representativeRepaymentTable: ReadonlyArray<{
                readonly __typename?: 'RepresentativeRepayment'
                readonly freshRounds: number
                readonly frozenRounds: number
                readonly apr: number
                readonly annualInterestRate: number
                readonly repaymentMonths: number
                readonly loanAmount: Gaia.Money
                readonly totalPayable: Gaia.Money
                readonly payableMonthly: Gaia.Money
                readonly payableMonthlyUncapped: Gaia.Money
              }>
            } | null
            readonly clinic: {
              readonly __typename?: 'Clinic'
              readonly id: string
              readonly name: string
            }
            readonly pathway: {
              readonly __typename?: 'TreatmentProfile'
              readonly embryosStored?: number | null
              readonly rolePartner?: {
                readonly __typename?: 'PathwayIndividual'
                readonly dateOfBirth?: string | null
              } | null
            }
          }
        | {
            readonly __typename: 'LetoPlanQuote'
            readonly protectionFee: Gaia.Money
            readonly cycleLiabilityPostDiscount: Gaia.Money
            readonly refundSchema: ReadonlyArray<number>
            readonly cyclesCovered: number
            readonly maxPaymentPeriodYears: number
            readonly id: string
            readonly variant: PlanProductVariant
            readonly expiresAt: string
            readonly lastViewedAt?: string | null
            readonly repaymentPeriods: number
            readonly annualInterestRate: number
            readonly coverPeriods: number
            readonly firstTreatmentWithinPeriods: number
            readonly procedures: ReadonlyArray<IvfProcedure>
            readonly status: QuoteStatus
            readonly repaymentScenariosOverPeriod: ReadonlyArray<{
              readonly __typename?: 'LetoRepaymentScenarioForPeriod'
              readonly period: string
              readonly scenarios: ReadonlyArray<{
                readonly __typename?: 'LetoRepaymentScenario'
                readonly numberOfCyclesStarted: number
                readonly fixedCycleCost: Gaia.Money
                readonly protectionFee: Gaia.Money
                readonly apr: number
                readonly totalFixedCycleCost: Gaia.Money
                readonly totalPayable: Gaia.Money
                readonly minimumMonthlyRepayment: Gaia.Money
                readonly refund: {
                  readonly __typename?: 'RefundScenario'
                  readonly discount: number
                  readonly reducedLoanAmount: Gaia.Money
                  readonly reducedTotalPayable: Gaia.Money
                  readonly reducedMinimumMonthlyRepayment: Gaia.Money
                }
              }>
            }>
            readonly clinic: {
              readonly __typename?: 'Clinic'
              readonly id: string
              readonly name: string
            }
            readonly pathway: {
              readonly __typename?: 'TreatmentProfile'
              readonly embryosStored?: number | null
              readonly rolePartner?: {
                readonly __typename?: 'PathwayIndividual'
                readonly dateOfBirth?: string | null
              } | null
            }
          }
      >
    } | null
  }
}

export type GetPlanQuotesQueryVariables = Exact<{
  filters?: InputMaybe<PlanQuotesFiltersInput>
}>

export type GetPlanQuotesQuery = {
  readonly __typename?: 'Query'
  readonly viewer: {
    readonly __typename?: 'Viewer'
    readonly id: string
    readonly user?: {
      readonly __typename?: 'User'
      readonly id: string
      readonly planQuotes: ReadonlyArray<
        | {
            readonly __typename: 'IoPlanQuote'
            readonly monthlyMembershipLiability: Gaia.Money
            readonly roundsCovered: number
            readonly freshPremium?: Gaia.Money | null
            readonly freshLiability: Gaia.Money
            readonly frozenPremium?: Gaia.Money | null
            readonly frozenLiability: Gaia.Money
            readonly maxFinancedFreshRounds?: number | null
            readonly id: string
            readonly variant: PlanProductVariant
            readonly expiresAt: string
            readonly lastViewedAt?: string | null
            readonly repaymentPeriods: number
            readonly annualInterestRate: number
            readonly coverPeriods: number
            readonly firstTreatmentWithinPeriods: number
            readonly procedures: ReadonlyArray<IvfProcedure>
            readonly status: QuoteStatus
            readonly clinic: {
              readonly __typename?: 'Clinic'
              readonly id: string
              readonly name: string
            }
            readonly pathway: {
              readonly __typename?: 'TreatmentProfile'
              readonly embryosStored?: number | null
              readonly rolePartner?: {
                readonly __typename?: 'PathwayIndividual'
                readonly dateOfBirth?: string | null
              } | null
            }
          }
        | {
            readonly __typename: 'LetoPlanQuote'
            readonly protectionFee: Gaia.Money
            readonly id: string
            readonly variant: PlanProductVariant
            readonly expiresAt: string
            readonly lastViewedAt?: string | null
            readonly repaymentPeriods: number
            readonly annualInterestRate: number
            readonly coverPeriods: number
            readonly firstTreatmentWithinPeriods: number
            readonly procedures: ReadonlyArray<IvfProcedure>
            readonly status: QuoteStatus
            readonly clinic: {
              readonly __typename?: 'Clinic'
              readonly id: string
              readonly name: string
            }
            readonly pathway: {
              readonly __typename?: 'TreatmentProfile'
              readonly embryosStored?: number | null
              readonly rolePartner?: {
                readonly __typename?: 'PathwayIndividual'
                readonly dateOfBirth?: string | null
              } | null
            }
          }
      >
    } | null
  }
}

export type QuotesQueryVariables = Exact<{ [key: string]: never }>

export type QuotesQuery = {
  readonly __typename?: 'Query'
  readonly viewer: {
    readonly __typename?: 'Viewer'
    readonly id: string
    readonly canViewPredictions: boolean
    readonly user?: {
      readonly __typename?: 'User'
      readonly id: string
      readonly referrerClinicId?: string | null
      readonly contactNumber?: string | null
      readonly hasPartner?: boolean | null
      readonly usaState: UsaState
      readonly planQuotes: ReadonlyArray<
        | {
            readonly __typename?: 'IoPlanQuote'
            readonly id: string
            readonly expiresAt: string
            readonly procedures: ReadonlyArray<IvfProcedure>
            readonly status: QuoteStatus
            readonly clinic: {
              readonly __typename?: 'Clinic'
              readonly id: string
              readonly name: string
            }
            readonly profile: {
              readonly __typename?: 'TreatmentProfile'
              readonly id?: string | null
              readonly inputs?: {
                readonly __typename?: 'TreatmentProfileInputs'
                readonly procedures: ReadonlyArray<IvfProcedure>
              } | null
            }
          }
        | {
            readonly __typename?: 'LetoPlanQuote'
            readonly id: string
            readonly expiresAt: string
            readonly procedures: ReadonlyArray<IvfProcedure>
            readonly status: QuoteStatus
            readonly clinic: {
              readonly __typename?: 'Clinic'
              readonly id: string
              readonly name: string
            }
            readonly profile: {
              readonly __typename?: 'TreatmentProfile'
              readonly id?: string | null
              readonly inputs?: {
                readonly __typename?: 'TreatmentProfileInputs'
                readonly procedures: ReadonlyArray<IvfProcedure>
              } | null
            }
          }
      >
      readonly quoteRequests: ReadonlyArray<{
        readonly __typename?: 'QuoteRequest'
        readonly id: string
        readonly unlistedClinicName?: string | null
        readonly isPending: boolean
        readonly clinic?: {
          readonly __typename?: 'Clinic'
          readonly id: string
          readonly name: string
        } | null
      }>
    } | null
  }
}

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String']
}>

export type RequestPasswordResetMutation = {
  readonly __typename?: 'Mutation'
  readonly requestPasswordReset?: boolean | null
}

export type ResetUserPasswordMutationVariables = Exact<{
  token: Scalars['String']
  newPassword: Scalars['String']
}>

export type ResetUserPasswordMutation = {
  readonly __typename?: 'Mutation'
  readonly resetUserPassword?: boolean | null
}

export type GetQuoteCollectionQueryVariables = Exact<{
  quoteCollectionId: Scalars['ID']
}>

export type GetQuoteCollectionQuery = {
  readonly __typename?: 'Query'
  readonly viewer: {
    readonly __typename?: 'Viewer'
    readonly id: string
    readonly canViewPredictions: boolean
    readonly user?: {
      readonly __typename?: 'User'
      readonly id: string
      readonly referrerClinicId?: string | null
      readonly contactNumber?: string | null
      readonly hasPartner?: boolean | null
      readonly usaState: UsaState
      readonly quoteCollections: ReadonlyArray<{
        readonly __typename?: 'QuoteCollection'
        readonly id: string
        readonly procedures: ReadonlyArray<IvfProcedure>
        readonly bundleProductExperimentId?: string | null
        readonly planQuoteId?: string | null
        readonly clinic: {
          readonly __typename?: 'Clinic'
          readonly name: string
        }
        readonly bundles?: {
          readonly __typename?: 'BundleProductExperiment'
          readonly metaData?: {
            readonly __typename?: 'BundleProductExperimentMetaData'
            readonly products: ReadonlyArray<{
              readonly __typename?: 'BundleProductExperimentProducts'
              readonly name: string
              readonly variants: ReadonlyArray<{
                readonly __typename?: 'BundleProductExperimentVariant'
                readonly cycles: number
                readonly refund: number
                readonly price: Gaia.Money
              }>
            }>
          } | null
        } | null
        readonly leto?:
          | { readonly __typename?: 'IoPlanQuote'; readonly id: string }
          | {
              readonly __typename?: 'LetoPlanQuote'
              readonly protectionFee: Gaia.Money
              readonly cycleLiabilityPostDiscount: Gaia.Money
              readonly refundSchema: ReadonlyArray<number>
              readonly id: string
            }
          | null
      }>
    } | null
  }
}

export type RequestOwnQuoteMutationVariables = Exact<{
  requestOwnQuoteInput: RequestOwnQuoteInput
}>

export type RequestOwnQuoteMutation = {
  readonly __typename?: 'Mutation'
  readonly requestOwnQuote: {
    readonly __typename?: 'RequestOwnQuoteResponse'
    readonly success: boolean
  }
}

export type CheckOpenBankingConnectionStatusMutationVariables = Exact<{
  individuals: ReadonlyArray<RiskIndividualRole> | RiskIndividualRole
}>

export type CheckOpenBankingConnectionStatusMutation = {
  readonly __typename?: 'Mutation'
  readonly checkOpenBankingConnectionStatus:
    | {
        readonly __typename?: 'CheckOpenBankingConnectionStatusError'
        readonly error: string
      }
    | {
        readonly __typename?: 'CheckOpenBankingConnectionStatusOk'
        readonly value: ReadonlyArray<{
          readonly __typename?: 'OpenBankingConnectionStatus'
          readonly individual: RiskIndividualRole
          readonly status: OpenBankingConnectionStatuses
        }>
      }
}

export type RequestOpenBankingLinkMutationVariables = Exact<{
  creditProfileId: Scalars['ID']
}>

export type RequestOpenBankingLinkMutation = {
  readonly __typename?: 'Mutation'
  readonly requestOpenBankingLink:
    | {
        readonly __typename?: 'RequestOpenBankingLinkError'
        readonly error: string
      }
    | {
        readonly __typename?: 'RequestOpenBankingLinkOk'
        readonly value: string
      }
}

export type ProfileQueryVariables = Exact<{ [key: string]: never }>

export type ProfileQuery = {
  readonly __typename?: 'Query'
  readonly viewer: {
    readonly __typename?: 'Viewer'
    readonly id: string
    readonly canViewPredictions: boolean
    readonly user?: {
      readonly __typename?: 'User'
      readonly id: string
      readonly firstName?: string | null
      readonly lastName?: string | null
      readonly email: string
      readonly isLeto: boolean
      readonly isUxOverhaul?: boolean | null
      readonly nextGaiaStep: NextGaiaStep
      readonly partnerEmail?: string | null
      readonly partnerFirstName?: string | null
      readonly contactNumber?: string | null
      readonly ivfJourneyStage?: IvfJourneyStage | null
      readonly referrerClinicId?: string | null
      readonly usaState: UsaState
      readonly tags: ReadonlyArray<string>
      readonly rejection?: {
        readonly __typename?: 'Rejection'
        readonly reasons?: ReadonlyArray<RejectionReason> | null
      } | null
      readonly activeCreditApplication?: {
        readonly __typename?: 'CreditApplication'
        readonly status: CreditApplicationStatus
        readonly externalApplicationId?: string | null
      } | null
      readonly treatmentProofDocumentList: ReadonlyArray<{
        readonly __typename?: 'TreatmentProofDocument'
        readonly id: string
      }>
      readonly planQuotes: ReadonlyArray<
        | {
            readonly __typename?: 'IoPlanQuote'
            readonly roundsCovered: number
            readonly freshPremium?: Gaia.Money | null
            readonly frozenPremium?: Gaia.Money | null
            readonly id: string
            readonly variant: PlanProductVariant
            readonly expiresAt: string
            readonly lastViewedAt?: string | null
            readonly coverPeriods: number
            readonly procedures: ReadonlyArray<IvfProcedure>
            readonly status: QuoteStatus
            readonly clinic: {
              readonly __typename?: 'Clinic'
              readonly id: string
              readonly name: string
            }
            readonly profile: {
              readonly __typename?: 'TreatmentProfile'
              readonly id?: string | null
              readonly inputs?: {
                readonly __typename?: 'TreatmentProfileInputs'
                readonly procedures: ReadonlyArray<IvfProcedure>
              } | null
            }
          }
        | {
            readonly __typename?: 'LetoPlanQuote'
            readonly perCycleMembershipLiability: Gaia.Money
            readonly protectionFee: Gaia.Money
            readonly id: string
            readonly variant: PlanProductVariant
            readonly expiresAt: string
            readonly lastViewedAt?: string | null
            readonly coverPeriods: number
            readonly procedures: ReadonlyArray<IvfProcedure>
            readonly status: QuoteStatus
            readonly clinic: {
              readonly __typename?: 'Clinic'
              readonly id: string
              readonly name: string
            }
            readonly profile: {
              readonly __typename?: 'TreatmentProfile'
              readonly id?: string | null
              readonly inputs?: {
                readonly __typename?: 'TreatmentProfileInputs'
                readonly procedures: ReadonlyArray<IvfProcedure>
              } | null
            }
          }
      >
      readonly quoteRequests: ReadonlyArray<{
        readonly __typename?: 'QuoteRequest'
        readonly id: string
        readonly unlistedClinicName?: string | null
        readonly createdAt: string
        readonly isPending: boolean
        readonly requestedVariant?: PlanProductVariant | null
        readonly clinic?: {
          readonly __typename?: 'Clinic'
          readonly id: string
          readonly name: string
        } | null
      }>
      readonly treatmentProfile?: {
        readonly __typename?: 'TreatmentProfile'
        readonly id?: string | null
        readonly inputs?: {
          readonly __typename?: 'TreatmentProfileInputs'
          readonly procedures: ReadonlyArray<IvfProcedure>
          readonly diagnoses: ReadonlyArray<FertilityDiagnosis>
          readonly roleEmbryoCarrier: {
            readonly __typename?: 'PathwayIndividual'
            readonly height?: Gaia.Height | null
            readonly weight?: Gaia.Weight | null
            readonly relationship: IndividualRelationship
          }
          readonly rolePartner: {
            readonly __typename?: 'PathwayIndividual'
            readonly relationship: IndividualRelationship
            readonly sex: IndividualSex
          }
        } | null
      } | null
    } | null
  }
}

export type UpdateTreatmentMutationVariables = Exact<{
  wholeProfile?: InputMaybe<TreatmentWholeInput>
}>

export type UpdateTreatmentMutation = {
  readonly __typename?: 'Mutation'
  readonly updateOwnTreatmentProfile: {
    readonly __typename?: 'TreatmentProfile'
    readonly status: TreatmentProfileStatus
  }
}

export type WholeTreatmentQueryVariables = Exact<{ [key: string]: never }>

export type WholeTreatmentQuery = {
  readonly __typename?: 'Query'
  readonly viewer: {
    readonly __typename?: 'Viewer'
    readonly id: string
    readonly user?: {
      readonly __typename?: 'User'
      readonly id: string
      readonly firstName?: string | null
      readonly partnerFirstName?: string | null
      readonly treatmentProfile?: {
        readonly __typename?: 'TreatmentProfile'
        readonly id?: string | null
        readonly status: TreatmentProfileStatus
        readonly inputs?: {
          readonly __typename?: 'TreatmentProfileInputs'
          readonly diagnoses: ReadonlyArray<FertilityDiagnosis>
          readonly diagnosesDescription?: string | null
          readonly knowsAmh?: boolean | null
          readonly explicitProcedures?: ReadonlyArray<ExplicitIvfProcedure> | null
          readonly haveAchievedLiveBirthPreviously?: boolean | null
          readonly eggsStored?: boolean | null
          readonly numEggsStored?: number | null
          readonly hasEmbryosStored?: boolean | null
          readonly eggsStoredAge?: number | null
          readonly previousIvf?: boolean | null
          readonly previousIvfRounds?: number | null
          readonly previousIvfRoundResultingInLiveBirth?: number | null
          readonly haveAchievedIvfLiveBirthPreviously?: boolean | null
          readonly previousProcedures: ReadonlyArray<IvfProcedure>
          readonly lastTransferType?: EmbryoTransferType | null
          readonly lastFreshEggsCollected?: number | null
          readonly lastFreshEmbryosCreated?: number | null
          readonly lastEmbryosTransferred?: number | null
          readonly blastocystAge?: number | null
          readonly embryosStored?: number | null
          readonly previousConsultations: ReadonlyArray<ConsultationType>
          readonly extraInformationFromUser?: string | null
          readonly previousPregnanciesCount?: number | null
          readonly previousLiveBirthsCount?: number | null
          readonly roleMember: {
            readonly __typename?: 'PathwayIndividual'
            readonly relationship: IndividualRelationship
            readonly sex: IndividualSex
            readonly dateOfBirth?: string | null
            readonly height?: Gaia.Height | null
            readonly weight?: Gaia.Weight | null
          }
          readonly rolePartner: {
            readonly __typename?: 'PathwayIndividual'
            readonly relationship: IndividualRelationship
            readonly sex: IndividualSex
            readonly dateOfBirth?: string | null
            readonly height?: Gaia.Height | null
            readonly weight?: Gaia.Weight | null
          }
          readonly roleEggProvider: {
            readonly __typename?: 'PathwayIndividual'
            readonly relationship: IndividualRelationship
            readonly dateOfBirth?: string | null
            readonly sex: IndividualSex
            readonly amh?: Gaia.Amh | null
          }
          readonly roleSpermProvider: {
            readonly __typename?: 'PathwayIndividual'
            readonly relationship: IndividualRelationship
            readonly dateOfBirth?: string | null
            readonly sex: IndividualSex
          }
          readonly roleEmbryoCarrier: {
            readonly __typename?: 'PathwayIndividual'
            readonly relationship: IndividualRelationship
            readonly dateOfBirth?: string | null
            readonly sex: IndividualSex
          }
        } | null
      } | null
    } | null
  }
}

export type RequestUploadTreatmentProofPresignedUrlMutationVariables = Exact<{
  [key: string]: never
}>

export type RequestUploadTreatmentProofPresignedUrlMutation = {
  readonly __typename?: 'Mutation'
  readonly requestUploadTreatmentProofPresignedUrl: {
    readonly __typename?: 'PreSignedObject'
    readonly url: string
    readonly id: string
  }
}

export type UploadTreatmentProofDocumentMutationVariables = Exact<{
  document: UploadDocumentInput
}>

export type UploadTreatmentProofDocumentMutation = {
  readonly __typename?: 'Mutation'
  readonly uploadTreatmentProofDocument:
    | {
        readonly __typename?: 'UploadTreatmentProofDocumentError'
        readonly error: string
      }
    | {
        readonly __typename?: 'UploadTreatmentProofDocumentOk'
        readonly value: {
          readonly __typename?: 'TreatmentProofDocument'
          readonly id: string
          readonly createdAt: string
        }
      }
}

export type DownloadTreatmentProofDocumentMutationVariables = Exact<{
  path: Scalars['String']
}>

export type DownloadTreatmentProofDocumentMutation = {
  readonly __typename?: 'Mutation'
  readonly requestViewTreatmentProofPresignedUrl: string
}

export type ViewTreatmentProofListQueryVariables = Exact<{
  [key: string]: never
}>

export type ViewTreatmentProofListQuery = {
  readonly __typename?: 'Query'
  readonly viewer: {
    readonly __typename?: 'Viewer'
    readonly user?: {
      readonly __typename?: 'User'
      readonly treatmentProofDocumentList: ReadonlyArray<{
        readonly __typename?: 'TreatmentProofDocument'
        readonly id: string
        readonly documentUrn: string
        readonly createdAt: string
        readonly deletedAt?: string | null
        readonly updatedAt: string
      }>
    } | null
  }
}

export const SharedRepresentativeRepaymentFragmentDoc = gql`
  fragment sharedRepresentativeRepayment on RepresentativeRepayment {
    freshRounds
    frozenRounds
    apr
    annualInterestRate
    repaymentMonths
    loanAmount
    totalPayable
    payableMonthly
    payableMonthlyUncapped
  }
`
export const NavigationDocument = gql`
  query navigation {
    viewer {
      user {
        treatmentProfile {
          status
        }
        treatmentProofDocumentList {
          id
        }
      }
    }
  }
`

/**
 * **useNavigationQuery**
 *
 * To run a query within a React component, call `useNavigationQuery`
 * and pass it any options that fit your needs. When your component
 * renders, `useNavigationQuery` returns an object from Apollo Client
 * that contains loading, error, and data properties you can use to
 * render your UI.
 *
 * @example Const { data, loading, error } = useNavigationQuery({
 * variables: { }, });
 *
 * @param baseOptions Options that will be passed into the query,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options;
 */
export function useNavigationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    NavigationQuery,
    NavigationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<NavigationQuery, NavigationQueryVariables>(
    NavigationDocument,
    options
  )
}
export function useNavigationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NavigationQuery,
    NavigationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<NavigationQuery, NavigationQueryVariables>(
    NavigationDocument,
    options
  )
}
export type NavigationQueryHookResult = ReturnType<typeof useNavigationQuery>
export type NavigationLazyQueryHookResult = ReturnType<
  typeof useNavigationLazyQuery
>
export type NavigationQueryResult = Apollo.QueryResult<
  NavigationQuery,
  NavigationQueryVariables
>
export const MeDocument = gql`
  query me {
    me: viewer {
      id
      user {
        id
        firstName
        lastName
        isUxOverhaul
      }
    }
  }
`

/**
 * **useMeQuery**
 *
 * To run a query within a React component, call `useMeQuery` and pass
 * it any options that fit your needs. When your component renders,
 * `useMeQuery` returns an object from Apollo Client that contains
 * loading, error, and data properties you can use to render your UI.
 *
 * @example Const { data, loading, error } = useMeQuery({ variables: {
 * }, });
 *
 * @param baseOptions Options that will be passed into the query,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options;
 */
export function useMeQuery(
  baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options)
}
export function useMeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options)
}
export type MeQueryHookResult = ReturnType<typeof useMeQuery>
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>
export const ClinicsDocument = gql`
  query clinics($country: Country) {
    clinics(country: $country, page: { offset: 0, first: 300 }) {
      data {
        id
        name
        usaState
      }
    }
  }
`

/**
 * **useClinicsQuery**
 *
 * To run a query within a React component, call `useClinicsQuery` and
 * pass it any options that fit your needs. When your component renders,
 * `useClinicsQuery` returns an object from Apollo Client that contains
 * loading, error, and data properties you can use to render your UI.
 *
 * @example Const { data, loading, error } = useClinicsQuery({
 * variables: { country: // value for 'country' }, });
 *
 * @param baseOptions Options that will be passed into the query,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options;
 */
export function useClinicsQuery(
  baseOptions?: Apollo.QueryHookOptions<ClinicsQuery, ClinicsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ClinicsQuery, ClinicsQueryVariables>(
    ClinicsDocument,
    options
  )
}
export function useClinicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ClinicsQuery, ClinicsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ClinicsQuery, ClinicsQueryVariables>(
    ClinicsDocument,
    options
  )
}
export type ClinicsQueryHookResult = ReturnType<typeof useClinicsQuery>
export type ClinicsLazyQueryHookResult = ReturnType<typeof useClinicsLazyQuery>
export type ClinicsQueryResult = Apollo.QueryResult<
  ClinicsQuery,
  ClinicsQueryVariables
>
export const AccountDocument = gql`
  query account {
    viewer {
      id
      user {
        id
        email
        firstName
        lastName
        contactNumber
        address {
          line1
          line2
          city
          county
          country
          postcode
        }
      }
    }
  }
`

/**
 * **useAccountQuery**
 *
 * To run a query within a React component, call `useAccountQuery` and
 * pass it any options that fit your needs. When your component renders,
 * `useAccountQuery` returns an object from Apollo Client that contains
 * loading, error, and data properties you can use to render your UI.
 *
 * @example Const { data, loading, error } = useAccountQuery({
 * variables: { }, });
 *
 * @param baseOptions Options that will be passed into the query,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options;
 */
export function useAccountQuery(
  baseOptions?: Apollo.QueryHookOptions<AccountQuery, AccountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AccountQuery, AccountQueryVariables>(
    AccountDocument,
    options
  )
}
export function useAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AccountQuery, AccountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AccountQuery, AccountQueryVariables>(
    AccountDocument,
    options
  )
}
export type AccountQueryHookResult = ReturnType<typeof useAccountQuery>
export type AccountLazyQueryHookResult = ReturnType<typeof useAccountLazyQuery>
export type AccountQueryResult = Apollo.QueryResult<
  AccountQuery,
  AccountQueryVariables
>
export const UpdateOwnAddressDocument = gql`
  mutation UpdateOwnAddress($address: AddressInput!) {
    updateOwnAddress(address: $address) {
      address {
        line1
        line2
        postcode
        city
        county
        country
      }
    }
  }
`
export type UpdateOwnAddressMutationFn = Apollo.MutationFunction<
  UpdateOwnAddressMutation,
  UpdateOwnAddressMutationVariables
>

/**
 * **useUpdateOwnAddressMutation**
 *
 * To run a mutation, you first call `useUpdateOwnAddressMutation`
 * within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOwnAddressMutation` returns a
 * tuple that includes:
 *
 * - A mutate function that you can call at any time to execute the
 *   mutation
 * - An object with fields that represent the current status of the
 *   mutation's execution
 *
 * @example Const [updateOwnAddressMutation, { data, loading, error }] =
 * useUpdateOwnAddressMutation({ variables: { address: // value for
 * 'address' }, });
 *
 * @param baseOptions Options that will be passed into the mutation,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 */
export function useUpdateOwnAddressMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOwnAddressMutation,
    UpdateOwnAddressMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateOwnAddressMutation,
    UpdateOwnAddressMutationVariables
  >(UpdateOwnAddressDocument, options)
}
export type UpdateOwnAddressMutationHookResult = ReturnType<
  typeof useUpdateOwnAddressMutation
>
export type UpdateOwnAddressMutationResult =
  Apollo.MutationResult<UpdateOwnAddressMutation>
export type UpdateOwnAddressMutationOptions = Apollo.BaseMutationOptions<
  UpdateOwnAddressMutation,
  UpdateOwnAddressMutationVariables
>
export const UpdateOwnEmailAddressDocument = gql`
  mutation UpdateOwnEmailAddress($email: EmailAddress!) {
    updateOwnEmailAddress(email: $email) {
      id
      email
    }
  }
`
export type UpdateOwnEmailAddressMutationFn = Apollo.MutationFunction<
  UpdateOwnEmailAddressMutation,
  UpdateOwnEmailAddressMutationVariables
>

/**
 * **useUpdateOwnEmailAddressMutation**
 *
 * To run a mutation, you first call `useUpdateOwnEmailAddressMutation`
 * within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOwnEmailAddressMutation`
 * returns a tuple that includes:
 *
 * - A mutate function that you can call at any time to execute the
 *   mutation
 * - An object with fields that represent the current status of the
 *   mutation's execution
 *
 * @example Const [updateOwnEmailAddressMutation, { data, loading, error
 * }] = useUpdateOwnEmailAddressMutation({ variables: { email: // value
 * for 'email' }, });
 *
 * @param baseOptions Options that will be passed into the mutation,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 */
export function useUpdateOwnEmailAddressMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOwnEmailAddressMutation,
    UpdateOwnEmailAddressMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateOwnEmailAddressMutation,
    UpdateOwnEmailAddressMutationVariables
  >(UpdateOwnEmailAddressDocument, options)
}
export type UpdateOwnEmailAddressMutationHookResult = ReturnType<
  typeof useUpdateOwnEmailAddressMutation
>
export type UpdateOwnEmailAddressMutationResult =
  Apollo.MutationResult<UpdateOwnEmailAddressMutation>
export type UpdateOwnEmailAddressMutationOptions = Apollo.BaseMutationOptions<
  UpdateOwnEmailAddressMutation,
  UpdateOwnEmailAddressMutationVariables
>
export const UpdateOwnPasswordDocument = gql`
  mutation UpdateOwnPassword($currentPassword: String!, $newPassword: String!) {
    updateOwnPassword(
      currentPassword: $currentPassword
      newPassword: $newPassword
    )
  }
`
export type UpdateOwnPasswordMutationFn = Apollo.MutationFunction<
  UpdateOwnPasswordMutation,
  UpdateOwnPasswordMutationVariables
>

/**
 * **useUpdateOwnPasswordMutation**
 *
 * To run a mutation, you first call `useUpdateOwnPasswordMutation`
 * within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOwnPasswordMutation` returns a
 * tuple that includes:
 *
 * - A mutate function that you can call at any time to execute the
 *   mutation
 * - An object with fields that represent the current status of the
 *   mutation's execution
 *
 * @example Const [updateOwnPasswordMutation, { data, loading, error }]
 * = useUpdateOwnPasswordMutation({ variables: { currentPassword: //
 * value for 'currentPassword' newPassword: // value for 'newPassword'
 * }, });
 *
 * @param baseOptions Options that will be passed into the mutation,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 */
export function useUpdateOwnPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOwnPasswordMutation,
    UpdateOwnPasswordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateOwnPasswordMutation,
    UpdateOwnPasswordMutationVariables
  >(UpdateOwnPasswordDocument, options)
}
export type UpdateOwnPasswordMutationHookResult = ReturnType<
  typeof useUpdateOwnPasswordMutation
>
export type UpdateOwnPasswordMutationResult =
  Apollo.MutationResult<UpdateOwnPasswordMutation>
export type UpdateOwnPasswordMutationOptions = Apollo.BaseMutationOptions<
  UpdateOwnPasswordMutation,
  UpdateOwnPasswordMutationVariables
>
export const UpdateOwnPersonalInformationDocument = gql`
  mutation UpdateOwnPersonalInformation($info: UserUpdateInput!) {
    updateSelf(info: $info) {
      contactNumber
      firstName
      lastName
    }
  }
`
export type UpdateOwnPersonalInformationMutationFn = Apollo.MutationFunction<
  UpdateOwnPersonalInformationMutation,
  UpdateOwnPersonalInformationMutationVariables
>

/**
 * **useUpdateOwnPersonalInformationMutation**
 *
 * To run a mutation, you first call
 * `useUpdateOwnPersonalInformationMutation` within a React component
 * and pass it any options that fit your needs. When your component
 * renders, `useUpdateOwnPersonalInformationMutation` returns a tuple
 * that includes:
 *
 * - A mutate function that you can call at any time to execute the
 *   mutation
 * - An object with fields that represent the current status of the
 *   mutation's execution
 *
 * @example Const [updateOwnPersonalInformationMutation, { data,
 * loading, error }] = useUpdateOwnPersonalInformationMutation({
 * variables: { info: // value for 'info' }, });
 *
 * @param baseOptions Options that will be passed into the mutation,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 */
export function useUpdateOwnPersonalInformationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOwnPersonalInformationMutation,
    UpdateOwnPersonalInformationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateOwnPersonalInformationMutation,
    UpdateOwnPersonalInformationMutationVariables
  >(UpdateOwnPersonalInformationDocument, options)
}
export type UpdateOwnPersonalInformationMutationHookResult = ReturnType<
  typeof useUpdateOwnPersonalInformationMutation
>
export type UpdateOwnPersonalInformationMutationResult =
  Apollo.MutationResult<UpdateOwnPersonalInformationMutation>
export type UpdateOwnPersonalInformationMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateOwnPersonalInformationMutation,
    UpdateOwnPersonalInformationMutationVariables
  >
export const ActiveCreditApplicationDocument = gql`
  query activeCreditApplication {
    viewer {
      id
      user {
        id
        activeCreditApplication {
          id
          status
        }
      }
    }
  }
`

/**
 * **useActiveCreditApplicationQuery**
 *
 * To run a query within a React component, call
 * `useActiveCreditApplicationQuery` and pass it any options that fit
 * your needs. When your component renders,
 * `useActiveCreditApplicationQuery` returns an object from Apollo
 * Client that contains loading, error, and data properties you can use
 * to render your UI.
 *
 * @example Const { data, loading, error } =
 * useActiveCreditApplicationQuery({ variables: { }, });
 *
 * @param baseOptions Options that will be passed into the query,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options;
 */
export function useActiveCreditApplicationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ActiveCreditApplicationQuery,
    ActiveCreditApplicationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ActiveCreditApplicationQuery,
    ActiveCreditApplicationQueryVariables
  >(ActiveCreditApplicationDocument, options)
}
export function useActiveCreditApplicationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActiveCreditApplicationQuery,
    ActiveCreditApplicationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ActiveCreditApplicationQuery,
    ActiveCreditApplicationQueryVariables
  >(ActiveCreditApplicationDocument, options)
}
export type ActiveCreditApplicationQueryHookResult = ReturnType<
  typeof useActiveCreditApplicationQuery
>
export type ActiveCreditApplicationLazyQueryHookResult = ReturnType<
  typeof useActiveCreditApplicationLazyQuery
>
export type ActiveCreditApplicationQueryResult = Apollo.QueryResult<
  ActiveCreditApplicationQuery,
  ActiveCreditApplicationQueryVariables
>
export const CreateCreditApplicationDocument = gql`
  mutation CreateCreditApplication($individuals: [RiskIndividualRole!]!) {
    createCreditApplication(creditProfileIds: [], individuals: $individuals) {
      ... on CreateCreditApplicationOk {
        value
      }
      ... on CreateCreditApplicationError {
        error
      }
    }
  }
`
export type CreateCreditApplicationMutationFn = Apollo.MutationFunction<
  CreateCreditApplicationMutation,
  CreateCreditApplicationMutationVariables
>

/**
 * **useCreateCreditApplicationMutation**
 *
 * To run a mutation, you first call
 * `useCreateCreditApplicationMutation` within a React component and
 * pass it any options that fit your needs. When your component renders,
 * `useCreateCreditApplicationMutation` returns a tuple that includes:
 *
 * - A mutate function that you can call at any time to execute the
 *   mutation
 * - An object with fields that represent the current status of the
 *   mutation's execution
 *
 * @example Const [createCreditApplicationMutation, { data, loading,
 * error }] = useCreateCreditApplicationMutation({ variables: {
 * individuals: // value for 'individuals' }, });
 *
 * @param baseOptions Options that will be passed into the mutation,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 */
export function useCreateCreditApplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCreditApplicationMutation,
    CreateCreditApplicationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateCreditApplicationMutation,
    CreateCreditApplicationMutationVariables
  >(CreateCreditApplicationDocument, options)
}
export type CreateCreditApplicationMutationHookResult = ReturnType<
  typeof useCreateCreditApplicationMutation
>
export type CreateCreditApplicationMutationResult =
  Apollo.MutationResult<CreateCreditApplicationMutation>
export type CreateCreditApplicationMutationOptions = Apollo.BaseMutationOptions<
  CreateCreditApplicationMutation,
  CreateCreditApplicationMutationVariables
>
export const LatestCreditProfileDocument = gql`
  query latestCreditProfile($individual: RiskIndividualRole!) {
    viewer {
      id
      user {
        id
        firstName
        lastName
        dateOfBirth
        email
        partnerFirstName
        partnerLastName
        partnerEmail
        hasPartner
        treatmentProfile {
          inputs {
            roleMember {
              dateOfBirth
            }
            rolePartner {
              dateOfBirth
              sex
            }
          }
        }
        latestCreditProfile(individual: $individual) {
          __typename
          id
          namePrefix
          firstName
          lastName
          dateOfBirth
          email
          employmentStatus
          grossAnnualIncome
          dependents
          monthlyRentOrMortgage
          monthlyExpenses
          ... on GbCreditProfile {
            address {
              street
              city
              country
              houseNumber
              houseName
              flat
              postcode
              residentialStatus
              moveInDate
              source
            }
            previousAddresses {
              street
              city
              country
              houseNumber
              houseName
              flat
              postcode
              residentialStatus
              moveInDate
              source
            }
          }
          ... on UsCreditProfile {
            address {
              line1
              line2
              city
              state
              postcode
              countryCode
              moveInDate
              residentialStatus
              source
            }
            socialSecurityNumber
          }
        }
      }
    }
  }
`

/**
 * **useLatestCreditProfileQuery**
 *
 * To run a query within a React component, call
 * `useLatestCreditProfileQuery` and pass it any options that fit your
 * needs. When your component renders, `useLatestCreditProfileQuery`
 * returns an object from Apollo Client that contains loading, error,
 * and data properties you can use to render your UI.
 *
 * @example Const { data, loading, error } =
 * useLatestCreditProfileQuery({ variables: { individual: // value for
 * 'individual' }, });
 *
 * @param baseOptions Options that will be passed into the query,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options;
 */
export function useLatestCreditProfileQuery(
  baseOptions: Apollo.QueryHookOptions<
    LatestCreditProfileQuery,
    LatestCreditProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    LatestCreditProfileQuery,
    LatestCreditProfileQueryVariables
  >(LatestCreditProfileDocument, options)
}
export function useLatestCreditProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LatestCreditProfileQuery,
    LatestCreditProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    LatestCreditProfileQuery,
    LatestCreditProfileQueryVariables
  >(LatestCreditProfileDocument, options)
}
export type LatestCreditProfileQueryHookResult = ReturnType<
  typeof useLatestCreditProfileQuery
>
export type LatestCreditProfileLazyQueryHookResult = ReturnType<
  typeof useLatestCreditProfileLazyQuery
>
export type LatestCreditProfileQueryResult = Apollo.QueryResult<
  LatestCreditProfileQuery,
  LatestCreditProfileQueryVariables
>
export const SaveCreditProfileDocument = gql`
  mutation SaveCreditProfile($profile: CreditProfileInput!) {
    saveCreditProfile(profile: $profile) {
      ... on SaveCreditProfileOk {
        value {
          id
        }
      }
      ... on SaveCreditProfileError {
        error
      }
    }
  }
`
export type SaveCreditProfileMutationFn = Apollo.MutationFunction<
  SaveCreditProfileMutation,
  SaveCreditProfileMutationVariables
>

/**
 * **useSaveCreditProfileMutation**
 *
 * To run a mutation, you first call `useSaveCreditProfileMutation`
 * within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCreditProfileMutation` returns a
 * tuple that includes:
 *
 * - A mutate function that you can call at any time to execute the
 *   mutation
 * - An object with fields that represent the current status of the
 *   mutation's execution
 *
 * @example Const [saveCreditProfileMutation, { data, loading, error }]
 * = useSaveCreditProfileMutation({ variables: { profile: // value for
 * 'profile' }, });
 *
 * @param baseOptions Options that will be passed into the mutation,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 */
export function useSaveCreditProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveCreditProfileMutation,
    SaveCreditProfileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SaveCreditProfileMutation,
    SaveCreditProfileMutationVariables
  >(SaveCreditProfileDocument, options)
}
export type SaveCreditProfileMutationHookResult = ReturnType<
  typeof useSaveCreditProfileMutation
>
export type SaveCreditProfileMutationResult =
  Apollo.MutationResult<SaveCreditProfileMutation>
export type SaveCreditProfileMutationOptions = Apollo.BaseMutationOptions<
  SaveCreditProfileMutation,
  SaveCreditProfileMutationVariables
>
export const CheckForEmailVerifiedDocument = gql`
  query checkForEmailVerified($email: String) {
    getUserByEmailOrId(email: $email) {
      emailVerified
    }
  }
`

/**
 * **useCheckForEmailVerifiedQuery**
 *
 * To run a query within a React component, call
 * `useCheckForEmailVerifiedQuery` and pass it any options that fit your
 * needs. When your component renders, `useCheckForEmailVerifiedQuery`
 * returns an object from Apollo Client that contains loading, error,
 * and data properties you can use to render your UI.
 *
 * @example Const { data, loading, error } =
 * useCheckForEmailVerifiedQuery({ variables: { email: // value for
 * 'email' }, });
 *
 * @param baseOptions Options that will be passed into the query,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options;
 */
export function useCheckForEmailVerifiedQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CheckForEmailVerifiedQuery,
    CheckForEmailVerifiedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CheckForEmailVerifiedQuery,
    CheckForEmailVerifiedQueryVariables
  >(CheckForEmailVerifiedDocument, options)
}
export function useCheckForEmailVerifiedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckForEmailVerifiedQuery,
    CheckForEmailVerifiedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CheckForEmailVerifiedQuery,
    CheckForEmailVerifiedQueryVariables
  >(CheckForEmailVerifiedDocument, options)
}
export type CheckForEmailVerifiedQueryHookResult = ReturnType<
  typeof useCheckForEmailVerifiedQuery
>
export type CheckForEmailVerifiedLazyQueryHookResult = ReturnType<
  typeof useCheckForEmailVerifiedLazyQuery
>
export type CheckForEmailVerifiedQueryResult = Apollo.QueryResult<
  CheckForEmailVerifiedQuery,
  CheckForEmailVerifiedQueryVariables
>
export const VerifyEmailAddressDocument = gql`
  mutation VerifyEmailAddress($token: String!) {
    verifyEmailAddress(token: $token) {
      id
      emailVerified
    }
  }
`
export type VerifyEmailAddressMutationFn = Apollo.MutationFunction<
  VerifyEmailAddressMutation,
  VerifyEmailAddressMutationVariables
>

/**
 * **useVerifyEmailAddressMutation**
 *
 * To run a mutation, you first call `useVerifyEmailAddressMutation`
 * within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailAddressMutation` returns
 * a tuple that includes:
 *
 * - A mutate function that you can call at any time to execute the
 *   mutation
 * - An object with fields that represent the current status of the
 *   mutation's execution
 *
 * @example Const [verifyEmailAddressMutation, { data, loading, error }]
 * = useVerifyEmailAddressMutation({ variables: { token: // value for
 * 'token' }, });
 *
 * @param baseOptions Options that will be passed into the mutation,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 */
export function useVerifyEmailAddressMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyEmailAddressMutation,
    VerifyEmailAddressMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    VerifyEmailAddressMutation,
    VerifyEmailAddressMutationVariables
  >(VerifyEmailAddressDocument, options)
}
export type VerifyEmailAddressMutationHookResult = ReturnType<
  typeof useVerifyEmailAddressMutation
>
export type VerifyEmailAddressMutationResult =
  Apollo.MutationResult<VerifyEmailAddressMutation>
export type VerifyEmailAddressMutationOptions = Apollo.BaseMutationOptions<
  VerifyEmailAddressMutation,
  VerifyEmailAddressMutationVariables
>
export const RequestEmailVerificationDocument = gql`
  mutation RequestEmailVerification($email: String!) {
    requestEmailVerification(email: $email)
  }
`
export type RequestEmailVerificationMutationFn = Apollo.MutationFunction<
  RequestEmailVerificationMutation,
  RequestEmailVerificationMutationVariables
>

/**
 * **useRequestEmailVerificationMutation**
 *
 * To run a mutation, you first call
 * `useRequestEmailVerificationMutation` within a React component and
 * pass it any options that fit your needs. When your component renders,
 * `useRequestEmailVerificationMutation` returns a tuple that includes:
 *
 * - A mutate function that you can call at any time to execute the
 *   mutation
 * - An object with fields that represent the current status of the
 *   mutation's execution
 *
 * @example Const [requestEmailVerificationMutation, { data, loading,
 * error }] = useRequestEmailVerificationMutation({ variables: { email:
 * // value for 'email' }, });
 *
 * @param baseOptions Options that will be passed into the mutation,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 */
export function useRequestEmailVerificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestEmailVerificationMutation,
    RequestEmailVerificationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RequestEmailVerificationMutation,
    RequestEmailVerificationMutationVariables
  >(RequestEmailVerificationDocument, options)
}
export type RequestEmailVerificationMutationHookResult = ReturnType<
  typeof useRequestEmailVerificationMutation
>
export type RequestEmailVerificationMutationResult =
  Apollo.MutationResult<RequestEmailVerificationMutation>
export type RequestEmailVerificationMutationOptions =
  Apollo.BaseMutationOptions<
    RequestEmailVerificationMutation,
    RequestEmailVerificationMutationVariables
  >
export const AcceptPlanQuoteDocument = gql`
  mutation acceptPlanQuote($acceptPlanQuoteInput: AcceptPlanQuoteInput!) {
    acceptPlanQuote(acceptPlanQuoteInput: $acceptPlanQuoteInput) {
      acceptedAt
    }
  }
`
export type AcceptPlanQuoteMutationFn = Apollo.MutationFunction<
  AcceptPlanQuoteMutation,
  AcceptPlanQuoteMutationVariables
>

/**
 * **useAcceptPlanQuoteMutation**
 *
 * To run a mutation, you first call `useAcceptPlanQuoteMutation` within
 * a React component and pass it any options that fit your needs. When
 * your component renders, `useAcceptPlanQuoteMutation` returns a tuple
 * that includes:
 *
 * - A mutate function that you can call at any time to execute the
 *   mutation
 * - An object with fields that represent the current status of the
 *   mutation's execution
 *
 * @example Const [acceptPlanQuoteMutation, { data, loading, error }] =
 * useAcceptPlanQuoteMutation({ variables: { acceptPlanQuoteInput: //
 * value for 'acceptPlanQuoteInput' }, });
 *
 * @param baseOptions Options that will be passed into the mutation,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 */
export function useAcceptPlanQuoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptPlanQuoteMutation,
    AcceptPlanQuoteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AcceptPlanQuoteMutation,
    AcceptPlanQuoteMutationVariables
  >(AcceptPlanQuoteDocument, options)
}
export type AcceptPlanQuoteMutationHookResult = ReturnType<
  typeof useAcceptPlanQuoteMutation
>
export type AcceptPlanQuoteMutationResult =
  Apollo.MutationResult<AcceptPlanQuoteMutation>
export type AcceptPlanQuoteMutationOptions = Apollo.BaseMutationOptions<
  AcceptPlanQuoteMutation,
  AcceptPlanQuoteMutationVariables
>
export const TrackPlanQuoteViewDocument = gql`
  mutation trackPlanQuoteView($quoteId: ID!) {
    trackPlanQuoteView(quoteId: $quoteId) {
      ... on TrackPlanQuoteViewOk {
        ok
      }
    }
  }
`
export type TrackPlanQuoteViewMutationFn = Apollo.MutationFunction<
  TrackPlanQuoteViewMutation,
  TrackPlanQuoteViewMutationVariables
>

/**
 * **useTrackPlanQuoteViewMutation**
 *
 * To run a mutation, you first call `useTrackPlanQuoteViewMutation`
 * within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackPlanQuoteViewMutation` returns
 * a tuple that includes:
 *
 * - A mutate function that you can call at any time to execute the
 *   mutation
 * - An object with fields that represent the current status of the
 *   mutation's execution
 *
 * @example Const [trackPlanQuoteViewMutation, { data, loading, error }]
 * = useTrackPlanQuoteViewMutation({ variables: { quoteId: // value for
 * 'quoteId' }, });
 *
 * @param baseOptions Options that will be passed into the mutation,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 */
export function useTrackPlanQuoteViewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TrackPlanQuoteViewMutation,
    TrackPlanQuoteViewMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    TrackPlanQuoteViewMutation,
    TrackPlanQuoteViewMutationVariables
  >(TrackPlanQuoteViewDocument, options)
}
export type TrackPlanQuoteViewMutationHookResult = ReturnType<
  typeof useTrackPlanQuoteViewMutation
>
export type TrackPlanQuoteViewMutationResult =
  Apollo.MutationResult<TrackPlanQuoteViewMutation>
export type TrackPlanQuoteViewMutationOptions = Apollo.BaseMutationOptions<
  TrackPlanQuoteViewMutation,
  TrackPlanQuoteViewMutationVariables
>
export const GetPlanQuoteDocument = gql`
  query getPlanQuote($quoteId: ID!) {
    viewer {
      id
      user {
        id
        firstName
        partnerFirstName
        activeCreditApplication {
          status
        }
        planQuotes(filters: { ids: [$quoteId] }) {
          __typename
          id
          variant
          clinic {
            id
            name
          }
          expiresAt
          lastViewedAt
          repaymentPeriods
          annualInterestRate
          coverPeriods
          firstTreatmentWithinPeriods
          procedures
          pathway {
            rolePartner {
              dateOfBirth
            }
            embryosStored
          }
          status
          ... on IoPlanQuote {
            monthlyMembershipLiability
            roundsCovered
            freshPremium
            freshLiability
            frozenPremium
            frozenLiability
            maxFinancedFreshRounds
            representativeLoanExample {
              loanAmount
              payableMonthly
              totalPayable
              months
              apr
              freshRounds
              annualInterestRate
            }
            representativeRepaymentTable {
              ...sharedRepresentativeRepayment
            }
            financePlan {
              id
              annualInterestRate
              apr
              repaymentPeriodInMonths
              maxFinancedLiability
              representativeRepaymentTable {
                ...sharedRepresentativeRepayment
              }
            }
          }
          ... on LetoPlanQuote {
            protectionFee
            cycleLiabilityPostDiscount
            refundSchema
            cyclesCovered
            maxPaymentPeriodYears
            repaymentScenariosOverPeriod(
              periods: ["12", "24", "36", "48", "60", "72", "84", "96"]
            ) {
              period
              scenarios {
                numberOfCyclesStarted
                fixedCycleCost
                protectionFee
                refund {
                  discount
                  reducedLoanAmount
                  reducedTotalPayable
                  reducedMinimumMonthlyRepayment
                }
                apr
                totalFixedCycleCost
                totalPayable
                minimumMonthlyRepayment
              }
            }
          }
        }
      }
    }
  }
  ${SharedRepresentativeRepaymentFragmentDoc}
`

/**
 * **useGetPlanQuoteQuery**
 *
 * To run a query within a React component, call `useGetPlanQuoteQuery`
 * and pass it any options that fit your needs. When your component
 * renders, `useGetPlanQuoteQuery` returns an object from Apollo Client
 * that contains loading, error, and data properties you can use to
 * render your UI.
 *
 * @example Const { data, loading, error } = useGetPlanQuoteQuery({
 * variables: { quoteId: // value for 'quoteId' }, });
 *
 * @param baseOptions Options that will be passed into the query,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options;
 */
export function useGetPlanQuoteQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPlanQuoteQuery,
    GetPlanQuoteQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPlanQuoteQuery, GetPlanQuoteQueryVariables>(
    GetPlanQuoteDocument,
    options
  )
}
export function useGetPlanQuoteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPlanQuoteQuery,
    GetPlanQuoteQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetPlanQuoteQuery, GetPlanQuoteQueryVariables>(
    GetPlanQuoteDocument,
    options
  )
}
export type GetPlanQuoteQueryHookResult = ReturnType<
  typeof useGetPlanQuoteQuery
>
export type GetPlanQuoteLazyQueryHookResult = ReturnType<
  typeof useGetPlanQuoteLazyQuery
>
export type GetPlanQuoteQueryResult = Apollo.QueryResult<
  GetPlanQuoteQuery,
  GetPlanQuoteQueryVariables
>
export const GetPlanQuotesDocument = gql`
  query getPlanQuotes($filters: PlanQuotesFiltersInput) {
    viewer {
      id
      user {
        id
        planQuotes(filters: $filters) {
          __typename
          id
          variant
          clinic {
            id
            name
          }
          expiresAt
          lastViewedAt
          repaymentPeriods
          annualInterestRate
          coverPeriods
          firstTreatmentWithinPeriods
          procedures
          pathway {
            rolePartner {
              dateOfBirth
            }
            embryosStored
          }
          status
          ... on IoPlanQuote {
            monthlyMembershipLiability
            roundsCovered
            freshPremium
            freshLiability
            frozenPremium
            frozenLiability
            maxFinancedFreshRounds
          }
          ... on LetoPlanQuote {
            protectionFee
          }
        }
      }
    }
  }
`

/**
 * **useGetPlanQuotesQuery**
 *
 * To run a query within a React component, call `useGetPlanQuotesQuery`
 * and pass it any options that fit your needs. When your component
 * renders, `useGetPlanQuotesQuery` returns an object from Apollo Client
 * that contains loading, error, and data properties you can use to
 * render your UI.
 *
 * @example Const { data, loading, error } = useGetPlanQuotesQuery({
 * variables: { filters: // value for 'filters' }, });
 *
 * @param baseOptions Options that will be passed into the query,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options;
 */
export function useGetPlanQuotesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPlanQuotesQuery,
    GetPlanQuotesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPlanQuotesQuery, GetPlanQuotesQueryVariables>(
    GetPlanQuotesDocument,
    options
  )
}
export function useGetPlanQuotesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPlanQuotesQuery,
    GetPlanQuotesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetPlanQuotesQuery, GetPlanQuotesQueryVariables>(
    GetPlanQuotesDocument,
    options
  )
}
export type GetPlanQuotesQueryHookResult = ReturnType<
  typeof useGetPlanQuotesQuery
>
export type GetPlanQuotesLazyQueryHookResult = ReturnType<
  typeof useGetPlanQuotesLazyQuery
>
export type GetPlanQuotesQueryResult = Apollo.QueryResult<
  GetPlanQuotesQuery,
  GetPlanQuotesQueryVariables
>
export const QuotesDocument = gql`
  query quotes {
    viewer {
      id
      canViewPredictions
      user {
        id
        referrerClinicId
        contactNumber
        hasPartner
        usaState
        planQuotes {
          id
          expiresAt
          clinic {
            id
            name
          }
          procedures
          profile {
            id
            inputs {
              procedures
            }
          }
          status
        }
        quoteRequests {
          id
          clinic {
            id
            name
          }
          unlistedClinicName
          isPending
        }
      }
    }
  }
`

/**
 * **useQuotesQuery**
 *
 * To run a query within a React component, call `useQuotesQuery` and
 * pass it any options that fit your needs. When your component renders,
 * `useQuotesQuery` returns an object from Apollo Client that contains
 * loading, error, and data properties you can use to render your UI.
 *
 * @example Const { data, loading, error } = useQuotesQuery({ variables:
 * { }, });
 *
 * @param baseOptions Options that will be passed into the query,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options;
 */
export function useQuotesQuery(
  baseOptions?: Apollo.QueryHookOptions<QuotesQuery, QuotesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<QuotesQuery, QuotesQueryVariables>(
    QuotesDocument,
    options
  )
}
export function useQuotesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<QuotesQuery, QuotesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<QuotesQuery, QuotesQueryVariables>(
    QuotesDocument,
    options
  )
}
export type QuotesQueryHookResult = ReturnType<typeof useQuotesQuery>
export type QuotesLazyQueryHookResult = ReturnType<typeof useQuotesLazyQuery>
export type QuotesQueryResult = Apollo.QueryResult<
  QuotesQuery,
  QuotesQueryVariables
>
export const RequestPasswordResetDocument = gql`
  mutation RequestPasswordReset($email: String!) {
    requestPasswordReset(email: $email)
  }
`
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<
  RequestPasswordResetMutation,
  RequestPasswordResetMutationVariables
>

/**
 * **useRequestPasswordResetMutation**
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation`
 * within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation`
 * returns a tuple that includes:
 *
 * - A mutate function that you can call at any time to execute the
 *   mutation
 * - An object with fields that represent the current status of the
 *   mutation's execution
 *
 * @example Const [requestPasswordResetMutation, { data, loading, error
 * }] = useRequestPasswordResetMutation({ variables: { email: // value
 * for 'email' }, });
 *
 * @param baseOptions Options that will be passed into the mutation,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 */
export function useRequestPasswordResetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestPasswordResetMutation,
    RequestPasswordResetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RequestPasswordResetMutation,
    RequestPasswordResetMutationVariables
  >(RequestPasswordResetDocument, options)
}
export type RequestPasswordResetMutationHookResult = ReturnType<
  typeof useRequestPasswordResetMutation
>
export type RequestPasswordResetMutationResult =
  Apollo.MutationResult<RequestPasswordResetMutation>
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<
  RequestPasswordResetMutation,
  RequestPasswordResetMutationVariables
>
export const ResetUserPasswordDocument = gql`
  mutation ResetUserPassword($token: String!, $newPassword: String!) {
    resetUserPassword(token: $token, newPassword: $newPassword)
  }
`
export type ResetUserPasswordMutationFn = Apollo.MutationFunction<
  ResetUserPasswordMutation,
  ResetUserPasswordMutationVariables
>

/**
 * **useResetUserPasswordMutation**
 *
 * To run a mutation, you first call `useResetUserPasswordMutation`
 * within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPasswordMutation` returns a
 * tuple that includes:
 *
 * - A mutate function that you can call at any time to execute the
 *   mutation
 * - An object with fields that represent the current status of the
 *   mutation's execution
 *
 * @example Const [resetUserPasswordMutation, { data, loading, error }]
 * = useResetUserPasswordMutation({ variables: { token: // value for
 * 'token' newPassword: // value for 'newPassword' }, });
 *
 * @param baseOptions Options that will be passed into the mutation,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 */
export function useResetUserPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetUserPasswordMutation,
    ResetUserPasswordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ResetUserPasswordMutation,
    ResetUserPasswordMutationVariables
  >(ResetUserPasswordDocument, options)
}
export type ResetUserPasswordMutationHookResult = ReturnType<
  typeof useResetUserPasswordMutation
>
export type ResetUserPasswordMutationResult =
  Apollo.MutationResult<ResetUserPasswordMutation>
export type ResetUserPasswordMutationOptions = Apollo.BaseMutationOptions<
  ResetUserPasswordMutation,
  ResetUserPasswordMutationVariables
>
export const GetQuoteCollectionDocument = gql`
  query getQuoteCollection($quoteCollectionId: ID!) {
    viewer {
      id
      canViewPredictions
      user {
        id
        referrerClinicId
        contactNumber
        hasPartner
        usaState
        quoteCollections(filters: { ids: [$quoteCollectionId] }) {
          id
          clinic {
            name
          }
          procedures
          bundleProductExperimentId
          bundles {
            metaData {
              products {
                name
                variants {
                  cycles
                  refund
                  price
                }
              }
            }
          }
          planQuoteId
          leto {
            id
            ... on LetoPlanQuote {
              protectionFee
              cycleLiabilityPostDiscount
              refundSchema
            }
          }
        }
      }
    }
  }
`

/**
 * **useGetQuoteCollectionQuery**
 *
 * To run a query within a React component, call
 * `useGetQuoteCollectionQuery` and pass it any options that fit your
 * needs. When your component renders, `useGetQuoteCollectionQuery`
 * returns an object from Apollo Client that contains loading, error,
 * and data properties you can use to render your UI.
 *
 * @example Const { data, loading, error } =
 * useGetQuoteCollectionQuery({ variables: { quoteCollectionId: // value
 * for 'quoteCollectionId' }, });
 *
 * @param baseOptions Options that will be passed into the query,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options;
 */
export function useGetQuoteCollectionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetQuoteCollectionQuery,
    GetQuoteCollectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetQuoteCollectionQuery,
    GetQuoteCollectionQueryVariables
  >(GetQuoteCollectionDocument, options)
}
export function useGetQuoteCollectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQuoteCollectionQuery,
    GetQuoteCollectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetQuoteCollectionQuery,
    GetQuoteCollectionQueryVariables
  >(GetQuoteCollectionDocument, options)
}
export type GetQuoteCollectionQueryHookResult = ReturnType<
  typeof useGetQuoteCollectionQuery
>
export type GetQuoteCollectionLazyQueryHookResult = ReturnType<
  typeof useGetQuoteCollectionLazyQuery
>
export type GetQuoteCollectionQueryResult = Apollo.QueryResult<
  GetQuoteCollectionQuery,
  GetQuoteCollectionQueryVariables
>
export const RequestOwnQuoteDocument = gql`
  mutation RequestOwnQuote($requestOwnQuoteInput: RequestOwnQuoteInput!) {
    requestOwnQuote(requestOwnQuoteInput: $requestOwnQuoteInput) {
      success
    }
  }
`
export type RequestOwnQuoteMutationFn = Apollo.MutationFunction<
  RequestOwnQuoteMutation,
  RequestOwnQuoteMutationVariables
>

/**
 * **useRequestOwnQuoteMutation**
 *
 * To run a mutation, you first call `useRequestOwnQuoteMutation` within
 * a React component and pass it any options that fit your needs. When
 * your component renders, `useRequestOwnQuoteMutation` returns a tuple
 * that includes:
 *
 * - A mutate function that you can call at any time to execute the
 *   mutation
 * - An object with fields that represent the current status of the
 *   mutation's execution
 *
 * @example Const [requestOwnQuoteMutation, { data, loading, error }] =
 * useRequestOwnQuoteMutation({ variables: { requestOwnQuoteInput: //
 * value for 'requestOwnQuoteInput' }, });
 *
 * @param baseOptions Options that will be passed into the mutation,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 */
export function useRequestOwnQuoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestOwnQuoteMutation,
    RequestOwnQuoteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RequestOwnQuoteMutation,
    RequestOwnQuoteMutationVariables
  >(RequestOwnQuoteDocument, options)
}
export type RequestOwnQuoteMutationHookResult = ReturnType<
  typeof useRequestOwnQuoteMutation
>
export type RequestOwnQuoteMutationResult =
  Apollo.MutationResult<RequestOwnQuoteMutation>
export type RequestOwnQuoteMutationOptions = Apollo.BaseMutationOptions<
  RequestOwnQuoteMutation,
  RequestOwnQuoteMutationVariables
>
export const CheckOpenBankingConnectionStatusDocument = gql`
  mutation CheckOpenBankingConnectionStatus(
    $individuals: [RiskIndividualRole!]!
  ) {
    checkOpenBankingConnectionStatus(individuals: $individuals) {
      ... on CheckOpenBankingConnectionStatusOk {
        value {
          individual
          status
        }
      }
      ... on CheckOpenBankingConnectionStatusError {
        error
      }
    }
  }
`
export type CheckOpenBankingConnectionStatusMutationFn =
  Apollo.MutationFunction<
    CheckOpenBankingConnectionStatusMutation,
    CheckOpenBankingConnectionStatusMutationVariables
  >

/**
 * **useCheckOpenBankingConnectionStatusMutation**
 *
 * To run a mutation, you first call
 * `useCheckOpenBankingConnectionStatusMutation` within a React
 * component and pass it any options that fit your needs. When your
 * component renders, `useCheckOpenBankingConnectionStatusMutation`
 * returns a tuple that includes:
 *
 * - A mutate function that you can call at any time to execute the
 *   mutation
 * - An object with fields that represent the current status of the
 *   mutation's execution
 *
 * @example Const [checkOpenBankingConnectionStatusMutation, { data,
 * loading, error }] = useCheckOpenBankingConnectionStatusMutation({
 * variables: { individuals: // value for 'individuals' }, });
 *
 * @param baseOptions Options that will be passed into the mutation,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 */
export function useCheckOpenBankingConnectionStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CheckOpenBankingConnectionStatusMutation,
    CheckOpenBankingConnectionStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CheckOpenBankingConnectionStatusMutation,
    CheckOpenBankingConnectionStatusMutationVariables
  >(CheckOpenBankingConnectionStatusDocument, options)
}
export type CheckOpenBankingConnectionStatusMutationHookResult = ReturnType<
  typeof useCheckOpenBankingConnectionStatusMutation
>
export type CheckOpenBankingConnectionStatusMutationResult =
  Apollo.MutationResult<CheckOpenBankingConnectionStatusMutation>
export type CheckOpenBankingConnectionStatusMutationOptions =
  Apollo.BaseMutationOptions<
    CheckOpenBankingConnectionStatusMutation,
    CheckOpenBankingConnectionStatusMutationVariables
  >
export const RequestOpenBankingLinkDocument = gql`
  mutation RequestOpenBankingLink($creditProfileId: ID!) {
    requestOpenBankingLink(creditProfileId: $creditProfileId) {
      ... on RequestOpenBankingLinkOk {
        value
      }
      ... on RequestOpenBankingLinkError {
        error
      }
    }
  }
`
export type RequestOpenBankingLinkMutationFn = Apollo.MutationFunction<
  RequestOpenBankingLinkMutation,
  RequestOpenBankingLinkMutationVariables
>

/**
 * **useRequestOpenBankingLinkMutation**
 *
 * To run a mutation, you first call `useRequestOpenBankingLinkMutation`
 * within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestOpenBankingLinkMutation`
 * returns a tuple that includes:
 *
 * - A mutate function that you can call at any time to execute the
 *   mutation
 * - An object with fields that represent the current status of the
 *   mutation's execution
 *
 * @example Const [requestOpenBankingLinkMutation, { data, loading,
 * error }] = useRequestOpenBankingLinkMutation({ variables: {
 * creditProfileId: // value for 'creditProfileId' }, });
 *
 * @param baseOptions Options that will be passed into the mutation,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 */
export function useRequestOpenBankingLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestOpenBankingLinkMutation,
    RequestOpenBankingLinkMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RequestOpenBankingLinkMutation,
    RequestOpenBankingLinkMutationVariables
  >(RequestOpenBankingLinkDocument, options)
}
export type RequestOpenBankingLinkMutationHookResult = ReturnType<
  typeof useRequestOpenBankingLinkMutation
>
export type RequestOpenBankingLinkMutationResult =
  Apollo.MutationResult<RequestOpenBankingLinkMutation>
export type RequestOpenBankingLinkMutationOptions = Apollo.BaseMutationOptions<
  RequestOpenBankingLinkMutation,
  RequestOpenBankingLinkMutationVariables
>
export const ProfileDocument = gql`
  query profile {
    viewer {
      id
      canViewPredictions
      user {
        id
        firstName
        lastName
        email
        isLeto
        isUxOverhaul
        nextGaiaStep
        rejection {
          reasons
        }
        activeCreditApplication {
          status
          externalApplicationId
        }
        partnerEmail
        partnerFirstName
        contactNumber
        ivfJourneyStage
        treatmentProofDocumentList {
          id
        }
        planQuotes {
          id
          variant
          expiresAt
          lastViewedAt
          coverPeriods
          clinic {
            id
            name
          }
          procedures
          profile {
            id
            inputs {
              procedures
            }
          }
          status
          ... on IoPlanQuote {
            roundsCovered
            freshPremium
            frozenPremium
          }
          ... on LetoPlanQuote {
            perCycleMembershipLiability
            protectionFee
          }
        }
        quoteRequests {
          id
          clinic {
            id
            name
          }
          unlistedClinicName
          createdAt
          isPending
          requestedVariant
        }
        treatmentProfile {
          id
          inputs {
            procedures
            diagnoses
            roleEmbryoCarrier {
              height
              weight
              relationship
            }
            rolePartner {
              relationship
              sex
            }
          }
        }
        referrerClinicId
        usaState
        tags
      }
    }
  }
`

/**
 * **useProfileQuery**
 *
 * To run a query within a React component, call `useProfileQuery` and
 * pass it any options that fit your needs. When your component renders,
 * `useProfileQuery` returns an object from Apollo Client that contains
 * loading, error, and data properties you can use to render your UI.
 *
 * @example Const { data, loading, error } = useProfileQuery({
 * variables: { }, });
 *
 * @param baseOptions Options that will be passed into the query,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options;
 */
export function useProfileQuery(
  baseOptions?: Apollo.QueryHookOptions<ProfileQuery, ProfileQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProfileQuery, ProfileQueryVariables>(
    ProfileDocument,
    options
  )
}
export function useProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProfileQuery, ProfileQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProfileQuery, ProfileQueryVariables>(
    ProfileDocument,
    options
  )
}
export type ProfileQueryHookResult = ReturnType<typeof useProfileQuery>
export type ProfileLazyQueryHookResult = ReturnType<typeof useProfileLazyQuery>
export type ProfileQueryResult = Apollo.QueryResult<
  ProfileQuery,
  ProfileQueryVariables
>
export const UpdateTreatmentDocument = gql`
  mutation updateTreatment($wholeProfile: TreatmentWholeInput) {
    updateOwnTreatmentProfile(wholeProfile: $wholeProfile) {
      status
    }
  }
`
export type UpdateTreatmentMutationFn = Apollo.MutationFunction<
  UpdateTreatmentMutation,
  UpdateTreatmentMutationVariables
>

/**
 * **useUpdateTreatmentMutation**
 *
 * To run a mutation, you first call `useUpdateTreatmentMutation` within
 * a React component and pass it any options that fit your needs. When
 * your component renders, `useUpdateTreatmentMutation` returns a tuple
 * that includes:
 *
 * - A mutate function that you can call at any time to execute the
 *   mutation
 * - An object with fields that represent the current status of the
 *   mutation's execution
 *
 * @example Const [updateTreatmentMutation, { data, loading, error }] =
 * useUpdateTreatmentMutation({ variables: { wholeProfile: // value for
 * 'wholeProfile' }, });
 *
 * @param baseOptions Options that will be passed into the mutation,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 */
export function useUpdateTreatmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTreatmentMutation,
    UpdateTreatmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateTreatmentMutation,
    UpdateTreatmentMutationVariables
  >(UpdateTreatmentDocument, options)
}
export type UpdateTreatmentMutationHookResult = ReturnType<
  typeof useUpdateTreatmentMutation
>
export type UpdateTreatmentMutationResult =
  Apollo.MutationResult<UpdateTreatmentMutation>
export type UpdateTreatmentMutationOptions = Apollo.BaseMutationOptions<
  UpdateTreatmentMutation,
  UpdateTreatmentMutationVariables
>
export const WholeTreatmentDocument = gql`
  query wholeTreatment {
    viewer {
      id
      user {
        id
        firstName
        partnerFirstName
        treatmentProfile {
          id
          status
          inputs {
            diagnoses
            diagnosesDescription
            knowsAmh
            explicitProcedures
            haveAchievedLiveBirthPreviously
            eggsStored
            numEggsStored
            hasEmbryosStored
            eggsStoredAge
            roleMember {
              relationship
              sex
              dateOfBirth
              height
              weight
            }
            rolePartner {
              relationship
              sex
              dateOfBirth
              height
              weight
            }
            roleEggProvider {
              relationship
              dateOfBirth
              sex
              amh
            }
            roleSpermProvider {
              relationship
              dateOfBirth
              sex
            }
            roleEmbryoCarrier {
              relationship
              dateOfBirth
              sex
            }
            previousIvf
            previousIvfRounds
            previousIvfRoundResultingInLiveBirth
            haveAchievedIvfLiveBirthPreviously
            previousProcedures
            lastTransferType
            lastFreshEggsCollected
            lastFreshEmbryosCreated
            lastEmbryosTransferred
            blastocystAge
            embryosStored
            previousConsultations
            extraInformationFromUser
            previousPregnanciesCount
            previousLiveBirthsCount
          }
        }
      }
    }
  }
`

/**
 * **useWholeTreatmentQuery**
 *
 * To run a query within a React component, call
 * `useWholeTreatmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useWholeTreatmentQuery` returns an
 * object from Apollo Client that contains loading, error, and data
 * properties you can use to render your UI.
 *
 * @example Const { data, loading, error } = useWholeTreatmentQuery({
 * variables: { }, });
 *
 * @param baseOptions Options that will be passed into the query,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options;
 */
export function useWholeTreatmentQuery(
  baseOptions?: Apollo.QueryHookOptions<
    WholeTreatmentQuery,
    WholeTreatmentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<WholeTreatmentQuery, WholeTreatmentQueryVariables>(
    WholeTreatmentDocument,
    options
  )
}
export function useWholeTreatmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WholeTreatmentQuery,
    WholeTreatmentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<WholeTreatmentQuery, WholeTreatmentQueryVariables>(
    WholeTreatmentDocument,
    options
  )
}
export type WholeTreatmentQueryHookResult = ReturnType<
  typeof useWholeTreatmentQuery
>
export type WholeTreatmentLazyQueryHookResult = ReturnType<
  typeof useWholeTreatmentLazyQuery
>
export type WholeTreatmentQueryResult = Apollo.QueryResult<
  WholeTreatmentQuery,
  WholeTreatmentQueryVariables
>
export const RequestUploadTreatmentProofPresignedUrlDocument = gql`
  mutation RequestUploadTreatmentProofPresignedUrl {
    requestUploadTreatmentProofPresignedUrl {
      url
      id
    }
  }
`
export type RequestUploadTreatmentProofPresignedUrlMutationFn =
  Apollo.MutationFunction<
    RequestUploadTreatmentProofPresignedUrlMutation,
    RequestUploadTreatmentProofPresignedUrlMutationVariables
  >

/**
 * **useRequestUploadTreatmentProofPresignedUrlMutation**
 *
 * To run a mutation, you first call
 * `useRequestUploadTreatmentProofPresignedUrlMutation` within a React
 * component and pass it any options that fit your needs. When your
 * component renders,
 * `useRequestUploadTreatmentProofPresignedUrlMutation` returns a tuple
 * that includes:
 *
 * - A mutate function that you can call at any time to execute the
 *   mutation
 * - An object with fields that represent the current status of the
 *   mutation's execution
 *
 * @example Const [requestUploadTreatmentProofPresignedUrlMutation, {
 * data, loading, error }] =
 * useRequestUploadTreatmentProofPresignedUrlMutation({ variables: { },
 * });
 *
 * @param baseOptions Options that will be passed into the mutation,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 */
export function useRequestUploadTreatmentProofPresignedUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestUploadTreatmentProofPresignedUrlMutation,
    RequestUploadTreatmentProofPresignedUrlMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RequestUploadTreatmentProofPresignedUrlMutation,
    RequestUploadTreatmentProofPresignedUrlMutationVariables
  >(RequestUploadTreatmentProofPresignedUrlDocument, options)
}
export type RequestUploadTreatmentProofPresignedUrlMutationHookResult =
  ReturnType<typeof useRequestUploadTreatmentProofPresignedUrlMutation>
export type RequestUploadTreatmentProofPresignedUrlMutationResult =
  Apollo.MutationResult<RequestUploadTreatmentProofPresignedUrlMutation>
export type RequestUploadTreatmentProofPresignedUrlMutationOptions =
  Apollo.BaseMutationOptions<
    RequestUploadTreatmentProofPresignedUrlMutation,
    RequestUploadTreatmentProofPresignedUrlMutationVariables
  >
export const UploadTreatmentProofDocumentDocument = gql`
  mutation UploadTreatmentProofDocument($document: uploadDocumentInput!) {
    uploadTreatmentProofDocument(document: $document) {
      ... on UploadTreatmentProofDocumentOk {
        value {
          id
          createdAt
        }
      }
      ... on UploadTreatmentProofDocumentError {
        error
      }
    }
  }
`
export type UploadTreatmentProofDocumentMutationFn = Apollo.MutationFunction<
  UploadTreatmentProofDocumentMutation,
  UploadTreatmentProofDocumentMutationVariables
>

/**
 * **useUploadTreatmentProofDocumentMutation**
 *
 * To run a mutation, you first call
 * `useUploadTreatmentProofDocumentMutation` within a React component
 * and pass it any options that fit your needs. When your component
 * renders, `useUploadTreatmentProofDocumentMutation` returns a tuple
 * that includes:
 *
 * - A mutate function that you can call at any time to execute the
 *   mutation
 * - An object with fields that represent the current status of the
 *   mutation's execution
 *
 * @example Const [uploadTreatmentProofDocumentMutation, { data,
 * loading, error }] = useUploadTreatmentProofDocumentMutation({
 * variables: { document: // value for 'document' }, });
 *
 * @param baseOptions Options that will be passed into the mutation,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 */
export function useUploadTreatmentProofDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadTreatmentProofDocumentMutation,
    UploadTreatmentProofDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UploadTreatmentProofDocumentMutation,
    UploadTreatmentProofDocumentMutationVariables
  >(UploadTreatmentProofDocumentDocument, options)
}
export type UploadTreatmentProofDocumentMutationHookResult = ReturnType<
  typeof useUploadTreatmentProofDocumentMutation
>
export type UploadTreatmentProofDocumentMutationResult =
  Apollo.MutationResult<UploadTreatmentProofDocumentMutation>
export type UploadTreatmentProofDocumentMutationOptions =
  Apollo.BaseMutationOptions<
    UploadTreatmentProofDocumentMutation,
    UploadTreatmentProofDocumentMutationVariables
  >
export const DownloadTreatmentProofDocumentDocument = gql`
  mutation DownloadTreatmentProofDocument($path: String!) {
    requestViewTreatmentProofPresignedUrl(path: $path)
  }
`
export type DownloadTreatmentProofDocumentMutationFn = Apollo.MutationFunction<
  DownloadTreatmentProofDocumentMutation,
  DownloadTreatmentProofDocumentMutationVariables
>

/**
 * **useDownloadTreatmentProofDocumentMutation**
 *
 * To run a mutation, you first call
 * `useDownloadTreatmentProofDocumentMutation` within a React component
 * and pass it any options that fit your needs. When your component
 * renders, `useDownloadTreatmentProofDocumentMutation` returns a tuple
 * that includes:
 *
 * - A mutate function that you can call at any time to execute the
 *   mutation
 * - An object with fields that represent the current status of the
 *   mutation's execution
 *
 * @example Const [downloadTreatmentProofDocumentMutation, { data,
 * loading, error }] = useDownloadTreatmentProofDocumentMutation({
 * variables: { path: // value for 'path' }, });
 *
 * @param baseOptions Options that will be passed into the mutation,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 */
export function useDownloadTreatmentProofDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DownloadTreatmentProofDocumentMutation,
    DownloadTreatmentProofDocumentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DownloadTreatmentProofDocumentMutation,
    DownloadTreatmentProofDocumentMutationVariables
  >(DownloadTreatmentProofDocumentDocument, options)
}
export type DownloadTreatmentProofDocumentMutationHookResult = ReturnType<
  typeof useDownloadTreatmentProofDocumentMutation
>
export type DownloadTreatmentProofDocumentMutationResult =
  Apollo.MutationResult<DownloadTreatmentProofDocumentMutation>
export type DownloadTreatmentProofDocumentMutationOptions =
  Apollo.BaseMutationOptions<
    DownloadTreatmentProofDocumentMutation,
    DownloadTreatmentProofDocumentMutationVariables
  >
export const ViewTreatmentProofListDocument = gql`
  query ViewTreatmentProofList {
    viewer {
      user {
        treatmentProofDocumentList {
          id
          documentUrn
          createdAt
          deletedAt
          updatedAt
        }
      }
    }
  }
`

/**
 * **useViewTreatmentProofListQuery**
 *
 * To run a query within a React component, call
 * `useViewTreatmentProofListQuery` and pass it any options that fit
 * your needs. When your component renders,
 * `useViewTreatmentProofListQuery` returns an object from Apollo Client
 * that contains loading, error, and data properties you can use to
 * render your UI.
 *
 * @example Const { data, loading, error } =
 * useViewTreatmentProofListQuery({ variables: { }, });
 *
 * @param baseOptions Options that will be passed into the query,
 *   supported options are listed on:
 *   https://www.apollographql.com/docs/react/api/react-hooks/#options;
 */
export function useViewTreatmentProofListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ViewTreatmentProofListQuery,
    ViewTreatmentProofListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ViewTreatmentProofListQuery,
    ViewTreatmentProofListQueryVariables
  >(ViewTreatmentProofListDocument, options)
}
export function useViewTreatmentProofListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ViewTreatmentProofListQuery,
    ViewTreatmentProofListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ViewTreatmentProofListQuery,
    ViewTreatmentProofListQueryVariables
  >(ViewTreatmentProofListDocument, options)
}
export type ViewTreatmentProofListQueryHookResult = ReturnType<
  typeof useViewTreatmentProofListQuery
>
export type ViewTreatmentProofListLazyQueryHookResult = ReturnType<
  typeof useViewTreatmentProofListLazyQuery
>
export type ViewTreatmentProofListQueryResult = Apollo.QueryResult<
  ViewTreatmentProofListQuery,
  ViewTreatmentProofListQueryVariables
>
